import React, { useState, useEffect, Fragment, useMemo, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

// import LayoutHOC from "../../LayoutHOC";
import AddFieldDrawer from "../../GlobalFeature/Table/AddFieldDrawer";
import { useSidebar } from "../../SidebarContext";

// import MySpaceDocument from "./MySpaceDocument";
// import CsvUploadPreview from "./CsvUploadPreview";
import MenuOptionsDropdown from "./MenuOptionsToCreate";
import ManageFieldDrawer from "./ManageFieldDrawer";
import ErrorFallback from "./ErrorFallBack";

import { ReactComponent as ClosePopUpIcn } from "../../../assets/images/closePopUpIcn.svg";
import PlusIcon from "../../../assets/images/icons/PlusIcon";
import { ReactComponent as ThreeDotMenu } from "../../../assets/images/threeDotVertical.svg";
import { ReactComponent as SubTaskIcon } from "../../../assets/images/subTaskIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/deleteIconCoaTable.svg";
import { ReactComponent as PlusGrayIcon } from "../../../assets/images/icons/Blackplusicon.svg";
import { ReactComponent as CustomModuleEmptySvg } from "../../../assets/images/custom_module-empty.svg";
import { ReactComponent as AddTask } from "../../../assets/images/AddtaskComponent.svg";
import { ReactComponent as ExpandIcon } from "../../../assets/images/icons/Expand.svg";
import ManageIcon from "../../../assets/images/icons/ManageIcon";
import UniversalCardComponent from "../../UniversalComponents/UniversalCardComponent";

import CustomerReactTable from "../../UniversalComponents/CustomerReactTable";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
import HighlightedParagraph from "../../UniversalComponents/HighlightedParagraph";
import Button from "../../UniversalComponents/DefaultButton";
import ConfirmationDialog from "../../UniversalComponents/ConfirmationDialogMulti";
import TableListRowAddEditComponent from "../../UniversalComponents/BillingTableRowAddEdit";
import GetPersonAvatar from "../../UniversalComponents/GetPersonAvatar";
import Breadcrumb from "../../UniversalComponents/Breadcrumb";
import AddItemPlus from "../../UniversalComponents/AddItemPlus";
import { ReactComponent as NewExpandIcon } from "../../../assets/images/icons/ExpandIcon.svg";
import { ReactComponent as MultiRow } from "../../../assets/images/icons/MutliRow.svg";
import { ReactComponent as AddItemplus } from "../../../assets/images/icons/AddItems.svg";
import { ReactComponent as ActiveAddItem } from "../../../assets/images/icons/ActiveAddItem.svg";
import ConfirmationDialogMulti from "../../UniversalComponents/ConfirmationDialogMulti";
import DescriptionIcon from "@mui/icons-material/Description";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";

import {
  mySpaceAddColumnOptions,
  mySpaceAddField,
  mySpaceAddUpdateCell,
  mySpaceData,
  mySpaceDeleteColumns,
  mySpaceDeleteOption,
  mySpaceFieldOptions,
  mySpaceGetHeaders,
  mySpacePersonList,
  mySpaceTableBulkUpdateListValue,
  mySpaceTableColumnUpdate,
  mySpaceTableRowAddUpdate,
  mySpaceTableRowDelete,
} from "../../../utils/api/mySpaceApi";
import {
  checkAccessPermission,
  getCompanyId,
  getMySpaceColumnOrder,
  getMySpaceVisibleFields,
  getUserToken,
  setMySpaceColumnOrder,
  setMySpaceVisibleFields,
} from "../../../utils/utilityFunctions/localServices";
import {
  useLazyFetchPersonInTableQuery,
  useFetchCustomerTableDataNewMutation,
  useFetchAllCustomerValuesQuery,
} from "../../../utils/customer/customerTable";
import { pushAlert } from "../../../utils/alertSlice";
import { getUserTokeData } from "../../../utils/userSlice";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import {
  formatNegativeNumber,
  formatTextValue,
  getHexWithOpacity,
  getSentenceCase,
  IndeterminateCheckbox,
  safeJsonParse,
} from "../../../utils/utilityFunctions/stringUtility";
import ResponsiveTags from "../../../utils/utilityFunctions/ResponsiveTags";
import { hexToRgba } from "../../../utils/utilityFunctions/color";
import {
  addUpdateFieldValue,
  addUpdateHeader,
  addUpdateRow,
  deleteColumn,
  deleteColumnOption,
  deleteFieldOption,
  deleteRow,
  fetchColumnDropdownOptions,
  fetchHeaders,
  fetchHeaderValues,
} from "../../../utils/api/customModuleApi";

import { getCustomerId } from "../CustomerSlice";
import InternalNavigation from "../../UniversalComponents/InternalNavigation";
import FormDashboard from "./FormDashboard";
import ViewNotesDrawer from "../../GlobalFeature/Table/ExtraComponent/ViewNotesDrawer";
import DocumentModal from "../DocumentModal";
import DocumentDrawer from "./DocumentDrawer";
import TaskRadioButton from "../../UniversalComponents/CompletionCheckbox";
import { ReactComponent as TaskToDo } from "../../../assets/images/icons/TaskToDo.svg";
import { ReactComponent as DealToDo } from "../../../assets/images/icons/Deal.svg";
import { ReactComponent as LeadToDo } from "../../../assets/images/icons/LeadToDo.svg";
import { ReactComponent as ViewTask } from "../../../assets/images/ViewTaskCustomerTable.svg";
import AddTaskIcon from "@mui/icons-material/AddTask";
import { usePostApiMutation } from "../../../utils/customer/customerTaskTable";
import { NODE_URL, NODE_URL_V2 } from "../../../utils/constants";
import DynamicAddTaskPodModal from "../../Task/DynamicAddTaskPodModal";
import { useFetchAllTemplateQuery } from "../../../utils/customer/customerSelect";
import CustomRender from "../customer-other-details/CustomRender";
import TasListkModal from "../TasListkModal";
import {
  buildOptionsFromListCustomerPage,
  buildOptionsFromListForCustomDashboard,
  generateUniqueValuesForCustomDashboard,
} from "../../../utils/utilityFunctions/CustomerReactTable/CustomerUtility";
import InternalNavigationRounded from "../../UniversalComponents/InternalNavigationRounded";
import SubmoduleNav from "./SubmoduleNav";
import Submodules from "./Submodules";
import { getUserDateTime } from "../../../utils/utilityFunctions/UTCFormat";
import { Dialog } from "@mui/material";
import RedirectModulePreview from "./RedirectModulePreview";

const INPUT_LIST = [
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "email",
    inputName: "Email",
    baseInputType: "text",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "shortText",
    baseInputType: "text",
    inputName: "Short Text",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "longText",
    baseInputType: "text",
    inputName: "Long Text",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "hyperlink",
    inputName: "Hyperlink",
    baseInputType: "text",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "text",
    inputType: "url",
    inputName: "URL",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "number",
    inputName: "Number",
    baseInputType: "number",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "currency",
    inputName: "Currency",
    baseInputType: "number",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "percentage",
    inputName: "Percentage",
    baseInputType: "number",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "date",
    inputType: "date",
    inputName: "Date",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "datetime",
    inputName: "Date & Time",
    baseInputType: "date",
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "dropdown",
    inputType: "choice",
    inputName: `Choice`,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "person",
    inputName: "Person",
    baseInputType: "person",
  },
];

const CustomDashboard = ({
  customerId = null,
  propTemplateId = null,
  subNavitems,
  customerGData,
  isCompanyLevel = false,
  isCompanyModule = false,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const companyId = getCompanyId();
  const navigate = useNavigate();

  const [showSingleForm, setShowSingleForm] = useState({ show: false, data: null });
  const [hasPermission, setHasPermission] = useState(checkAccessPermission("Add & Manage Archive Customers"));

  const { templateId = null } = useParams();

  console.log(templateId, propTemplateId, "templateId---");

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [customerData, setCustomerData] = useState({});
  const [customerIdForCompanyLevel, setCustomerIdForCompanyLevel] = useState(null);
  const [activeSubmodule, setActiveSubmodule] = useState({});
  const [subModulesItems, setSubModulesItems] = useState([]);
  const [rowData, setRowData] = useState(null);

  const [categoryId, setCategoryId] = useState(null);
  //----------------------------------------------- URL TYPE AND CONTAINER ID CHECK -----------------------------------------------
  const { "*": wildcard } = useParams(); // everything after /my_space/

  const { type, urlContainerId, isShared } = useMemo(() => {
    if (!wildcard) return { type: null, urlContainerId: null, isShared: false };

    const parts = wildcard.split("/").filter(Boolean);
    const validTypes = ["folders", "tables"];

    let isShared = false;
    let type = null;
    let urlContainerId = null;

    // Case: /shared/folders or /shared/folders/:id
    if (parts[0] === "shared" && validTypes.includes(parts[1])) {
      isShared = true;
      type = parts[1];
      urlContainerId = parts[2] || null; // may be undefined
    }
    // Case: /folders or /folders/:id
    else if (validTypes.includes(parts[0])) {
      type = parts[0];
      urlContainerId = parts[1] || null;
    }

    return { type, urlContainerId, isShared };
  }, [wildcard]);

  console.log(type, urlContainerId, isShared, "type,urlContainerId,isShared---");

  //post the task pod data
  const [
    createUpdateTask,
    {
      data: TaskPodData,
      isLoading: TaskPodLoading,
      isError: isTaskPodError,
      isSuccess: isTaskPodSuccess,
      error: TaskPodErrordata,
    },
  ] = usePostApiMutation();

  //post the task pod data useEffect
  useEffect(() => {
    //loading
    if (TaskPodLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (isTaskPodSuccess) {
      dispatch(
        pushAlert({
          message: TaskPodData?.message,
          type: TaskPodData.success ? "success" : "danger", // success is not comming form backend
          visible: true,
        })
      );
      setSecondPopupOpen(false);
    }

    // catch block
    if (isTaskPodError) {
      dispatch(pushAlert({ message: TaskPodErrordata?.data?.message, type: "danger", visible: true }));
    }
  }, [isTaskPodSuccess, isTaskPodError, TaskPodLoading]);
  useEffect(() => {
    if (customerGData?.data[0]?.customer_data) {
      setCustomerData(customerGData?.data[0]?.customer_data[0]);
    }
  }, [customerGData?.data[0]?.customer_data]);

  //----------------------------------------------- URL TYPE AND CONTAINER ID CHECK -----------------------------------------------

  // TO MAKE TABLE-ID PERSISTENT IN URL FROM REFRESH
  // const queryParams = new URLSearchParams(location?.search);
  // const queryContainerId = queryParams.get("containerId")?.replace(/^"|"$/g, "");
  const [containerId, setContainerId] = useState(propTemplateId || templateId || null);
  const [showListView, setShowListView] = useState(type === "tables" ? true : false);

  console.log(containerId, "containerId---");

  // useEffect(() => {
  //   if (queryContainerId) {
  //     setContainerId(queryContainerId);
  //   }
  // }, [queryContainerId]);

  const [multiData, setMultiData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [showShareFileModal, setShowShareFileModal] = useState(false);
  const [headerConfigData, setHeaderConfigData] = useState([]);
  const [headerConfigDataRaw, setHeaderConfigDataRaw] = useState({});

  const [mySpaceBody, setMySpaceBodyData] = useState([]);
  const [mySpaceBodyRaw, setMySpaceBodyDataRaw] = useState({});
  const [dropdownOptionsData, setDropdownOptionsData] = useState([]);

  const [headerSingleFormat, setHeaderSingleFormat] = useState({});
  const [headerBodyFormat, setHeaderBodyFormat] = useState({});

  const [isApiLoading, setIsApiLoading] = useState(false);
  // const [iserror, setIsError] = useState(false);
  // const [selectedRecord, setSelectedRecord] = useState();

  // const [showCsvUploadPreview, setShowCsvUploadPreview] = useState(false);
  // const [csvFileData, setCsvFileData] = useState(null);

  const [lastSelectedRowIndex, setLastSelectedRowIndex] = useState(null);
  const [grouping, setGrouping] = useState([]);

  // const [mySpaceDocumentList, setMySpaceDocumentList] = useState([]);
  const [selectedtableRowId, setSelectedtableRowId] = useState(null);
  const [rowAddEditMode, setRowAddEditMode] = useState("add");

  const [isActive, setIsActive] = useState(false);

  const [showConfirmDialog, setShowConfirmDialog] = useState({ show: false, data: {} });
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showManageViewDrawer, setShowManageViewDrawer] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [tableColumnsVisibility, setTableColumnsVisibility] = useState({});
  const [isManageFieldOpen, setIsManageFieldOpen] = useState(false);
  const [isMangeHovered, setIsMangeHovered] = useState(false);

  const [isDetailsVisible, setDetailsVisible] = useState(false);

  const [columnOrder, setColumnOrder] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [resetPageIndex, setResetPageIndex] = useState(true);
  const [extraField, setExtraField] = useState(false);
  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();
  const [fieldOptionsData, setFieldOptionsData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [isEditableFieldModeActive, setIsEditableFieldModeActive] = useState(null);
  const [breadcrumpList, setBreadcrumpList] = useState([{ label: "My Space", isContainer: true }]);
  const [isActiveAddItem, setIsActiveAddItem] = useState(false);
  const [isDocumentOpen, setIsDocumentOpen] = useState(false);
  const [leadTypeValue, setLeadTypeValue] = useState("task");
  const [taskClickCustomer, setTaskClickCustomer] = useState(null);
  const [isTaskDrawerOpen, setIsTaskDrawerOpen] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [secondPopupOpen, setSecondPopupOpen] = useState(false);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [refetchBytask, setRefetchByTask] = useState(false);
  const [tableRowId, setTableRowId] = useState(null);

  // const [searchParams] = useSearchParams();
  // const tableId = searchParams.get('tableId');

  const reorderVisibleFields = (listViewData, draggedIndex, targetIndex) => {
    if (
      draggedIndex < 0 ||
      targetIndex < 0 ||
      draggedIndex >= listViewData.visible_fields.length ||
      targetIndex >= listViewData.visible_fields.length
    ) {
      return listViewData; // Return unchanged if indices are invalid
    }

    // Create a copy to prevent mutation
    const updatedVisibleFields = [...listViewData.visible_fields];

    // Remove the dragged item and insert it at the target position
    const [movedItem] = updatedVisibleFields.splice(draggedIndex, 1);
    updatedVisibleFields.splice(targetIndex, 0, movedItem);

    // Return the updated listViewData with new order
    return { ...listViewData, visible_fields: updatedVisibleFields };
  };
  // to get the label/name associated with the prop template id

  // function getLabelByTemplateId(items, propTemplateId) {
  //   if (!propTemplateId) return null;

  //   const match = items.find(it => {
  //     if (!it?.path || typeof it.path !== 'string') return false;
  //     if (!it.path.startsWith('/company-module/')) return false;

  //     // grab the last segment of the path (handles optional trailing slash)
  //     const lastSeg = it.path.replace(/\/+$/, '').split('/').pop();
  //     return lastSeg === propTemplateId;
  //   });

  //   return match?.label ?? null;
  // }

  //   const label = getLabelByTemplateId(localStorage?.getItem("mainMenu"), propTemplateId);

  // const handleReorderFields = (sourceIndex, targetIndex) => {
  //   console.log("fieldOrder", "Source Index:", sourceIndex, "Target Index:", targetIndex);

  //   const updatedData = reorderVisibleFields(columnVisibility, sourceIndex, targetIndex);
  //   setColumnVisibility(updatedData);

  //   // Store order state locally
  //   setMySpaceColumnOrder(containerId, ["select", ...updatedData.visible_fields]);

  //   setColumnOrder(["select", ...updatedData.visible_fields]);
  // };

  const fetchFieldOptions = useCallback(
    async (data) => {
      const columnHeaderData = headerConfigData?.find((header) => header?.value === data);
      if (columnHeaderData?.type === "dropdown" || columnHeaderData?.type === "multiselect") {
        const response = await fetchColumnDropdownOptions({ query: { field_name: columnHeaderData?.value } });

        if (response?.success || response?.status) {
          if (response?.data?.length > 0) {
            // const formatedResponse = response?.data?.map((data) => {
            //   return {
            //     value: data?.label,
            //     color_code: data?.color,
            //     uuid: data?.id,
            //     field_id: columnHeaderData?.id,
            //   };
            // });
            const formatedResponse = response?.data?.map((data) => {
              return {
                ...data,
                value: data?.label,
              };
            });

            setFieldOptionsData({ success: true, data: formatedResponse });
          } else {
            setFieldOptionsData({ success: true, data: [] });
          }
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.data?.message,
              type: "danger",
            })
          );
        }
      }
    },
    [headerConfigData]
  );

  const {
    refetch: refetchGetAllTemplate,
    data: GetAlltemplates,
    isLoading: isGetAllTemplatesLoading,
    isError: isGetAllTemplatesError,
    isSuccess: isGetAllTemplatesSuccess,
    error: GetAllTemplatesError,
  } = useFetchAllTemplateQuery();

  //create the task for row
  const handleSubmitTask = async (data) => {
    const templateId = GetAlltemplates?.data?.find(
      (template) => template?.template_name?.toLowerCase() === data?.category_id?.toLowerCase()
    )?.id;
    // if(templateId){
    //   setCategoryId(templateId)
    // }
    const {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      start_time,
      end_date,
      end_time,
      update_entire_series,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
      ...RemFormData
    } = data;

    const recurrence = {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      start_time,
      end_date,
      end_time,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
    };
    const OnlyDynamicFields = { ...RemFormData, start_date, end_date };

    const payload = {
      // row_id: tableRowId ? tableRowId : null,
      template_id: data ? templateId : null, // task create for the category
      data: OnlyDynamicFields,
      // update_single_recurrence: !taskid?.recurModal ? true : false,
      // edit_entire_recurrence: taskid?.recurModal ? true : false,
    };
    if (data?.is_recurrence) {
      payload.recurrence = recurrence;
    }
    createUpdateTask({
      data: payload,
      url: `${NODE_URL}template/create-task?row_id=${tableRowId}&template_id=${containerId}`,
    }); // module id
  };

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: getUserToken(), data: data, companyId: companyId?.company_id });
  };

  //For setting data in Header
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;

  const jsonStringFilter = (row, columnId, filterValue) => {
    const cellValue = row.getValue(columnId); // Convert to string
    return filterValue.every((filterStr) =>
      cellValue?.some((person) => person.email?.toLowerCase().includes(filterStr?.toLowerCase()))
    );
  };

  const multiSelectFilterFn = (row, columnId, filterValue) => {
    // If no filter is applied, return true (i.e. show the row)
    if (!filterValue || filterValue?.length === 0) return true;
    // Check if the row value is included in the selected values
    return filterValue.includes(row.getValue(columnId)?.value);
  };

  // Generate unique values for filters

  function generateUniqueValues(keys, opts = {}) {
    const { caseInsensitive = true } = opts;
    if (!Array.isArray(keys)) return [];

    const seen = new Set();
    const out = [];

    const norm = (v) => {
      if (v === null || v === undefined) return "";
      try {
        const s = String(v).trim();
        return caseInsensitive ? s.toLowerCase() : s;
      } catch {
        return "";
      }
    };

    const safeJsonParse = (s) => {
      try {
        return JSON.parse(s);
      } catch {
        return null;
      }
    };

    for (let i = 0; i < keys.length; i++) {
      const entry = keys[i];
      if (entry == null) continue;

      // 1) value is primitive (email / short-text / long-text / url)
      if (typeof entry?.value === "string" || typeof entry?.value === "number" || typeof entry?.value === "boolean") {
        const uniqueKey = norm(entry.value);
        if (uniqueKey && !seen.has(uniqueKey)) {
          seen.add(uniqueKey);
          out.push(entry); // keep full entry
        }
        continue;
      }

      // 2) value is an object (single-choice style with value: { id, value, color })
      if (entry?.value && typeof entry.value === "object" && !Array.isArray(entry.value)) {
        // handle hyperlink where entry.value might be a JSON string in some cases,
        // but here we've already filtered for object. check for nested value.value
        if (
          typeof entry.value.value === "string" ||
          typeof entry.value.value === "number" ||
          typeof entry.value.value === "boolean"
        ) {
          // uniqueness based on entry.value.value (per your updated single-choice case)
          const uniqueKey = norm(entry.value.value);
          if (uniqueKey && !seen.has(uniqueKey)) {
            seen.add(uniqueKey);
            out.push(entry); // keep full wrapper entry
          }
          continue;
        }

        // hyperlink where value might be a JSON-string inside value (rare if value already object),
        // or hyperlink-like object with textForUrl/url
        if (typeof entry.value.textForUrl === "string") {
          const uniqueKey = norm(entry.value.textForUrl);
          if (uniqueKey && !seen.has(uniqueKey)) {
            seen.add(uniqueKey);
            out.push(entry);
          }
          continue;
        }

        // fallback for object shapes: stringify to key
        const fallbackKey = norm(JSON.stringify(entry.value));
        if (fallbackKey && !seen.has(fallbackKey)) {
          seen.add(fallbackKey);
          out.push(entry);
        }
        continue;
      }

      // 3) value is an array (multiple-choice or people arrays)
      if (Array.isArray(entry?.value)) {
        // two possibilities:
        // - choices array (each item has value/id/color) -> push each inner choice object
        // - people array (each item has email) -> push each person object
        for (const inner of entry.value) {
          if (inner == null) continue;

          // if person-like (has email) -> uniqueness by email
          if (inner.email) {
            const uniqueKey = norm(inner.email);
            if (uniqueKey && !seen.has(uniqueKey)) {
              seen.add(uniqueKey);
              out.push(inner);
            }
            continue;
          }

          // choice-like -> uniqueness by inner.value
          if (inner.value !== undefined && inner.value !== null) {
            const uniqueKey = norm(inner.value);
            if (uniqueKey && !seen.has(uniqueKey)) {
              seen.add(uniqueKey);
              out.push(inner);
            }
            continue;
          }

          // fallback for inner items
          const fallbackKey = norm(JSON.stringify(inner));
          if (fallbackKey && !seen.has(fallbackKey)) {
            seen.add(fallbackKey);
            out.push(inner);
          }
        }
        continue;
      }

      // 4) hyperlink special case: sometimes entry.value is a JSON string (containing textForUrl/url)
      if (typeof entry?.value === "string") {
        const parsed = safeJsonParse(entry.value);
        if (parsed && typeof parsed === "object") {
          // use textForUrl if present (per your rule)
          if (parsed.textForUrl) {
            const uniqueKey = norm(parsed.textForUrl);
            if (uniqueKey && !seen.has(uniqueKey)) {
              seen.add(uniqueKey);
              // push the full entry, but you might want to push parsed object instead depending on consumer
              out.push(entry);
            }
            continue;
          }
          // else use url if available
          if (parsed.url) {
            const uniqueKey = norm(parsed.url);
            if (uniqueKey && !seen.has(uniqueKey)) {
              seen.add(uniqueKey);
              out.push(entry);
            }
            continue;
          }
        }

        // if parsing failed, already handled earlier primitives path, but keep fallback:
        const uniqueKey = norm(entry.value);
        if (uniqueKey && !seen.has(uniqueKey)) {
          seen.add(uniqueKey);
          out.push(entry);
        }
        continue;
      }

      // 5) fallback unknown shape: stringify and dedupe
      try {
        const fallbackKey = norm(JSON.stringify(entry));
        if (fallbackKey && !seen.has(fallbackKey)) {
          seen.add(fallbackKey);
          out.push(entry);
        }
      } catch (e) {
        // ignore unparsable entry
        continue;
      }
    }

    return out;
  }

  // Helper: safe JSON parse
  const safeParse = (s) => {
    try {
      if (typeof s !== "string") return null;
      return JSON.parse(s);
    } catch {
      return null;
    }
  };

  const normalize = (v) => {
    if (v === null || v === undefined) return "";
    return String(v).trim().toLowerCase();
  };

  // This extracts comparable strings from many shapes (primitives, wrapper objects, arrays, choice objects, people)
  const extractStringsFromEntry = (entry) => {
    if (entry == null) return [];

    // primitive
    if (["string", "number", "boolean"].includes(typeof entry)) {
      return [normalize(entry)];
    }

    // If entry is a JSON string (whole-entry string), try parse
    if (typeof entry === "string") {
      const parsedTop = safeParse(entry);
      if (parsedTop && typeof parsedTop === "object") {
        return extractStringsFromEntry(parsedTop);
      }
      return [normalize(entry)];
    }

    // If entry is an array: flatten inner items
    if (Array.isArray(entry)) {
      const res = [];
      for (const inner of entry) {
        if (inner == null) continue;
        // If inner is primitive
        if (["string", "number", "boolean"].includes(typeof inner)) {
          res.push(normalize(inner));
          continue;
        }
        // If inner has email (people)
        if (inner.email) {
          res.push(normalize(inner.email));
          continue;
        }
        // inner has value field (choice objects)
        if (inner.value !== undefined) {
          // case: inner.value is primitive
          if (["string", "number", "boolean"].includes(typeof inner.value)) {
            res.push(normalize(inner.value));
            continue;
          }
          // case: inner.value is object — try nested keys
          if (typeof inner.value === "object" && inner.value !== null) {
            // try inner.value.value first, then textForUrl, then url, then name, then email
            const iv = inner.value;
            if (iv.value !== undefined && ["string", "number", "boolean"].includes(typeof iv.value)) {
              res.push(normalize(iv.value));
              continue;
            }
            if (iv.textForUrl) {
              res.push(normalize(iv.textForUrl));
              continue;
            }
            if (iv.url) {
              res.push(normalize(iv.url));
              continue;
            }
            if (iv.name) {
              res.push(normalize(iv.name));
              continue;
            }
            if (iv.email) {
              res.push(normalize(iv.email));
              continue;
            }
          }
          // case: inner.value is stringified JSON
          if (typeof inner.value === "string") {
            const parsed = safeParse(inner.value);
            if (parsed && typeof parsed === "object") {
              const pick = parsed.textForUrl ?? parsed.url ?? parsed.value ?? parsed.name ?? parsed.email;
              if (pick) {
                res.push(normalize(pick));
                continue;
              }
            }
            // fallback to raw string
            res.push(normalize(inner.value));
            continue;
          }
        }

        // fallback: try common fields on inner
        if (inner.textForUrl) {
          res.push(normalize(inner.textForUrl));
          continue;
        }
        if (inner.url) {
          res.push(normalize(inner.url));
          continue;
        }
        if (inner.name) {
          res.push(normalize(inner.name));
          continue;
        }
        if (inner.value !== undefined && (typeof inner.value === "string" || typeof inner.value === "number")) {
          res.push(normalize(inner.value));
          continue;
        }

        // last resort: stringify inner (but normalized)
        try {
          res.push(normalize(JSON.stringify(inner)));
        } catch {
          // ignore
        }
      }
      return res.filter(Boolean);
    }

    // entry is an object (not array)
    if (typeof entry === "object") {
      // If person-like
      if (entry.email) return [normalize(entry.email)];

      // If entry looks like direct choice object {id, value, color}
      if (
        entry.value !== undefined &&
        (typeof entry.value === "string" || typeof entry.value === "number" || typeof entry.value === "boolean")
      ) {
        return [normalize(entry.value)];
      }

      // If entry.value is an array (wrapper that contains choices)
      if (Array.isArray(entry.value)) {
        return extractStringsFromEntry(entry.value);
      }

      // If entry.value is a string that might be JSON (hyperlink case)
      if (typeof entry.value === "string") {
        const parsedInner = safeParse(entry.value);
        if (parsedInner && typeof parsedInner === "object") {
          const pick =
            parsedInner.textForUrl ?? parsedInner.url ?? parsedInner.value ?? parsedInner.name ?? parsedInner.email;
          if (pick) return [normalize(pick)];
        }
        return [normalize(entry.value)];
      }

      // If entry.value is an object (wrapper style: { value: { value: "..." } })
      if (entry.value && typeof entry.value === "object") {
        const inner = entry.value;
        if (inner.value !== undefined && (typeof inner.value === "string" || typeof inner.value === "number")) {
          return [normalize(inner.value)];
        }
        if (inner.textForUrl) return [normalize(inner.textForUrl)];
        if (inner.url) return [normalize(inner.url)];
        if (inner.name) return [normalize(inner.name)];
        if (inner.email) return [normalize(inner.email)];
        // try one level deeper if inner.value is object
        if (inner.value && typeof inner.value === "object") {
          const deeper = inner.value;
          if (deeper.value !== undefined) return [normalize(deeper.value)];
          if (deeper.textForUrl) return [normalize(deeper.textForUrl)];
          if (deeper.url) return [normalize(deeper.url)];
        }
      }

      // fallback common fields directly on entry
      if (entry.textForUrl) return [normalize(entry.textForUrl)];
      if (entry.url) return [normalize(entry.url)];
      if (entry.name) return [normalize(entry.name)];

      // last resort: try to stringify a small subset (prefer primitive props)
      for (const k of Object.keys(entry)) {
        const v = entry[k];
        if (["string", "number", "boolean"].includes(typeof v)) {
          return [normalize(v)];
        }
      }

      // ultimate fallback: stringify whole object
      try {
        return [normalize(JSON.stringify(entry))];
      } catch {
        return [];
      }
    }

    return [];
  };

  // Main filter function: OR semantics, case-insensitive
  // const filterColumn = (row, columnId, filterValue) => {
  //   // No filter applied
  //   if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) return true;

  //   // Normalize filter values into a set of comparable strings
  //   const selectedSet = new Set();
  //   const fvArray = Array.isArray(filterValue) ? filterValue : [filterValue];

  //   for (const fv of fvArray) {
  //     if (fv == null) continue;

  //     // If fv is object (option.value could be original object)
  //     if (typeof fv === "object") {
  //       // If the option object is a wrapper like { value: { value: "..." } }
  //       if (fv.value !== undefined) {
  //         selectedSetAddFromEntry(fv.value, selectedSet);
  //       } else {
  //         // direct object filter value (like person or choice)
  //         selectedSetAddFromEntry(fv, selectedSet);
  //       }
  //       continue;
  //     }

  //     // If fv is a string: try parse (maybe JSON), otherwise primitive
  //     if (typeof fv === "string") {
  //       const p = safeParse(fv);
  //       if (p && typeof p === "object") {
  //         const arr = extractStringsFromEntry(p);
  //         arr.forEach((s) => s && selectedSet.add(s));
  //       } else {
  //         selectedSet.add(normalize(fv));
  //       }
  //       continue;
  //     }

  //     // number/boolean
  //     selectedSet.add(normalize(fv));
  //   }

  //   // Helper to add strings extracted from an entry into selectedSet
  //   function selectedSetAddFromEntry(entry, set) {
  //     const arr = extractStringsFromEntry(entry);
  //     arr.forEach((s) => s && set.add(s));
  //   }

  //   // Extract strings from the row cell and check membership
  //   const cell = row.getValue(columnId);
  //   const cellStrings = extractStringsFromEntry(cell);
  //   for (const s of cellStrings) {
  //     if (selectedSet.has(s)) return true;
  //   }
  //   return false;
  // };

  function filterColumn(row, columnId, filterValue) {
    // no filter => show
    if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) return true;

    const normalize = (v) => (v == null ? "" : String(v).trim().toLowerCase());

    // Extract canonical token(s) from an object/primitive. Returns array of strings (usually 0..n tokens).
    const extractTokens = (item) => {
      if (item == null) return [];

      // primitive
      if (typeof item === "string" || typeof item === "number" || typeof item === "boolean") {
        return [normalize(item)];
      }

      // object
      if (typeof item === "object") {
        const tokens = [];

        // prefer wrapper.value when primitive
        if (item.hasOwnProperty("value")) {
          const v = item.value;

          // primitive value
          if (v !== null && (typeof v === "string" || typeof v === "number" || typeof v === "boolean")) {
            tokens.push(normalize(v));
            return tokens;
          }

          // value is object -> prefer textForUrl, then value, then url
          if (v && typeof v === "object" && !Array.isArray(v)) {
            if (v.textForUrl) tokens.push(normalize(v.textForUrl));
            else if (v.value !== undefined && v.value !== null) tokens.push(normalize(v.value));
            else if (v.url) tokens.push(normalize(v.url));
            if (tokens.length) return tokens;
          }

          // value is array -> flatten inner objects and use each inner.value
          if (Array.isArray(v)) {
            for (const inner of v) {
              if (!inner || typeof inner !== "object") continue;
              if (inner.value !== undefined && inner.value !== null) tokens.push(normalize(inner.value));
              else if (inner.id !== undefined && inner.id !== null) tokens.push(normalize(inner.id));
            }
            if (tokens.length) return Array.from(new Set(tokens));
          }
        }

        // fallback: prefer id, label, email, name
        if (item.id !== undefined && item.id !== null) tokens.push(normalize(item.id));
        if (item.label !== undefined && item.label !== null) tokens.push(normalize(item.label));
        if (item.email !== undefined && item.email !== null) tokens.push(normalize(item.email));
        if (item.name !== undefined && item.name !== null) tokens.push(normalize(item.name));

        // final fallback: first primitive property
        if (tokens.length === 0) {
          for (const k of Object.keys(item)) {
            const v = item[k];
            if (v !== null && (typeof v === "string" || typeof v === "number" || typeof v === "boolean")) {
              tokens.push(normalize(v));
              break;
            }
          }
        }

        return Array.from(new Set(tokens)); // unique tokens
      }

      return [];
    };

    // Build selected token set
    const selected = new Set();
    const selArr = Array.isArray(filterValue) ? filterValue : [filterValue];
    for (const s of selArr) {
      const toks = extractTokens(s);
      for (const t of toks) if (t) selected.add(t);
    }
    if (selected.size === 0) return true;

    // Extract tokens from cell value
    const cell = row.getValue(columnId);
    if (cell == null) return false;

    const cellTokens = new Set();

    if (Array.isArray(cell)) {
      // flatten inner objects (case 4)
      for (const inner of cell) {
        const toks = extractTokens(inner);
        for (const t of toks) if (t) cellTokens.add(t);
      }
    } else {
      // wrapper object or primitive
      const toks = extractTokens(cell);
      for (const t of toks) if (t) cellTokens.add(t);
    }

    // OR semantics: any intersection -> match
    for (const t of selected) {
      if (cellTokens.has(t)) return true;
    }
    return false;
  }

  const handleMultiViewRow = (rowInfo = {}) => {
    console.log(rowInfo, "rowInfo---");
    // setRowData(rowInfo);
    navigate(`/workspace/record-preview/${propTemplateId}`, {
      state: { recordData: { id: rowInfo?.id, core_id: rowInfo?.core_id } },
    }); // nav
  };
  const handleEditRow = async (rowInfo = {}) => {
    const rowData = [];
    let columnMetaType;
    let columnLabel;
    for (let columnName of Object.keys(rowInfo)) {
      columnLabel = headerConfigData.find((item) => item?.value === columnName)?.label || columnName;
      columnMetaType = null;
      // TODO - CUSTOMER TABLE IS HAVING UNNECESSARY ID COLUMN...
      if (columnName === "id") {
        continue;
      }
      if (columnName === "folder_id") {
        continue;
      }
      if (columnLabel === "notes" || columnLabel === "Task") {
        continue;
      }

      // Finding column type
      let columnInfo = headerConfigData.find((item) => item?.value === columnName) || null;
      let columnDropdownOptions = [];

      // Initial value defined for text and value and updatingit later for dropdown/multiselect
      let columnValue = rowInfo[columnName]?.value;

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        if (!response?.success && !response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.label,
            color_code: data?.color,
          };
        });

        if (columnInfo?.type === "dropdown") {
          if (rowInfo[columnName]?.value?.id) {
            columnValue = [
              {
                value: rowInfo[columnName]?.value?.id,
                label: rowInfo[columnName]?.value?.value,
                color_code: rowInfo[columnName]?.value?.color,
              },
            ];
          } else {
            columnValue = [];
          }
        } else {
          if ((columnValue = rowInfo[columnName]?.value)) {
            columnValue = rowInfo[columnName]?.value?.map((cellOption) => {
              return {
                value: cellOption?.id,
                label: cellOption?.value,
                color_code: cellOption?.color,
              };
            });
          } else {
            columnValue = [];
          }
        }
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });

        columnValue = rowInfo[columnName]?.value?.map((cellOption) => {
          return {
            id: cellOption?.id,
            value: cellOption?.uuid,
            label: cellOption?.name,
            subLabel: cellOption?.email,
          };
        });
      } else if (columnInfo?.type === "text") {
        if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
          columnMetaType = columnInfo?.meta?.textFormat?.textSelectedOption;
        }
      } else if (columnInfo?.type === "date") {
        if (columnInfo?.meta?.absoluteType === "date") {
          columnMetaType = "Date";
        } else {
          columnMetaType = "DateTime";
        }
      }

      rowData.push({
        name: columnLabel || null,
        value: columnValue || null,
        type: columnInfo?.type || null,
        options: columnDropdownOptions || null,
        id: columnInfo?.id || null,
        columnMetaType: columnMetaType || null,
        row_id: rowInfo.id,
        sectionName: columnInfo?.sectionName,
        is_editable: columnInfo?.is_editable,
      });
    }

    setShowAddEditModal({ show: true, data: rowData });
    // setShowSingleForm({ show: true, data: rowData });
    setRowAddEditMode("edit");
  };

  const handleAddRow = async () => {
    // Finding column type
    let rowData = [];
    for (let columnInfo of headerConfigData) {
      let columnDropdownOptions = [];
      let columnMetaType = null;

      // TODO - CUSTOMER TABLE IS HAVING UNNECESSARY ID COLUMN...
      if (columnInfo?.label === "id") {
        continue;
      }
      if (columnInfo?.label === "folder_id") {
        continue;
      }
      if (columnInfo?.type === "note_template" || columnInfo?.type === "task_template") {
        continue;
      }

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        if (!response?.success && !response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.label,
            color_code: data?.color,
          };
        });
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });
      } else if (columnInfo?.type === "text") {
        // if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
        columnMetaType = columnInfo?.meta?.textFormat?.textSelectedOption;
        // }
      } else if (columnInfo?.type === "date") {
        if (columnInfo?.meta?.absoluteType === "date") {
          columnMetaType = "Date";
        } else {
          columnMetaType = "DateTime";
        }
      }

      rowData.push({
        name: columnInfo?.label || null,
        value: null, // Initial value defined for text and value and updatingit later for dropdown/multiselect
        type: columnInfo?.type || null,
        options: columnDropdownOptions || null,
        id: columnInfo?.id || null,
        columnMetaType: columnMetaType || null,
        is_editable: columnInfo?.is_editable,
        sectionName: columnInfo?.sectionName,
        row_id: null,
      });
    }
    setShowAddEditModal({ show: true, data: rowData });
  };

  const handleRowAddEditSubmit = async (formData) => {
    try {
      let finalRequestPayload = [];
      formData.forEach((inputData) => {
        if (inputData?.value === null) {
          return;
        }
        if (inputData?.type === "text" || inputData?.type === "number" || inputData?.type === "date") {
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: inputData?.value } },
          ];
        } else if (inputData?.type === "multiselect") {
          const modifiedValue = inputData?.value?.map((data) => {
            return data?.value;
          });
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: modifiedValue || [] } },
          ];
        } else if (inputData?.type === "dropdown") {
          const singleSelectedValue =
            inputData?.value && inputData?.value?.length > 0 ? inputData?.value[0]?.value : [];
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: singleSelectedValue || [] } },
          ];
        } else if (inputData?.type === "person" || inputData?.type === "multi_person") {
          const modifiedValue = inputData?.value?.map((data) => {
            return {
              id: data?.id,
              name: data?.label,
              email: data?.subLabel,
              uuid: data?.value,
            };
          });
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: modifiedValue || [] } },
          ];
        }
      });

      let payload = {};

      let columnFieldsData = {};

      finalRequestPayload?.forEach((columnData) => {
        columnFieldsData[columnData?.field_id] = { value: columnData?.value };
      });

      payload = {
        data: {
          data: columnFieldsData,
        },
      };

      if (formData?.[0]?.row_id) {
        payload.data.row_id = formData?.[0]?.row_id;
      } else {
        payload.data.core_id = customerIdForCompanyLevel || null;
      }

      const response = await addUpdateRow({ body: payload, query: { template_id: containerId, key: "u2_core" } });

      if (response?.success || response?.status) {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
        await fetchMySpaceHeaderConfig(containerId);
        setShowAddEditModal({});
        setSelectedtableRowId(null);
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message, type: "danger" }));
    }
  };

  // To display label from template id

  function getLabelByTemplateId(items, propTemplateId) {
    if (!propTemplateId) return null;

    const match = items.find((it) => {
      if (!it?.path || typeof it.path !== "string") return false;
      if (!it.path.startsWith("/company-module/")) return false;

      // grab the last segment of the path (handles optional trailing slash)
      const lastSeg = it.path.replace(/\/+$/, "").split("/").pop();
      return lastSeg === propTemplateId;
    });

    return match?.label ?? null;
  }

  const menuList = JSON.parse(localStorage.getItem("fullMenuList") || "[]");
  const label = getLabelByTemplateId(menuList, propTemplateId);

  useEffect(() => {
    if (!isCompanyLevel) return;
    setheaderProps({ name: getSentenceCase(label) });

    return () => {
      setheaderProps(null);
    };
  }, [setheaderProps, propTemplateId, label]);

  const [activeTab, setActiveTab] = useState("#All");
  const [isArchived, setIsArchived] = useState(false);

  const myUserData = localStorage.getItem("myUserData");
  const myUserDataParsed = JSON.parse(myUserData);
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const freshPollingCounter = useRef(0);

  const {
    data: AllCustomerData,
    refetch: refetchCustomerDataNodeOnly,
    isFetching: customerFetching,
    isLoading: customerLoading,
    isError: customerError,
  } = useFetchAllCustomerValuesQuery({
    token: getUserToken(),
    orgId: myUserDataParsed?.org_id,
    companyId: parsedCompanyData.company_id,
    limit: 1000,
    // viewName: "Universal",
    type: activeTab.replace("#", ""),
    isArchived: isArchived,
  });

  const refetchCustomerDataNode = useCallback(() => {
    freshPollingCounter.current = 0;
    refetchCustomerDataNodeOnly();
  }, [refetchCustomerDataNodeOnly, freshPollingCounter]);

  const TaskToDoConfig = {
    task: {
      icon: <TaskToDo />,
      color: "#984AEA",
    },
    deal: {
      icon: <DealToDo className="h-4 w-4" />,
      color: "#4C53D7",
    },
    lead: {
      icon: <LeadToDo className="h-4 w-4" />,
      color: "#4B9CA5",
    },
  };

  const closeSecondPopup = () => {
    setSecondPopupOpen(false);
  };

  const handleTaskClick = (rowData, leadType, rowId, e) => {
    console.log("rowData jajak", rowId);

    e.stopPropagation();
    setLeadTypeValue(leadType);
    setTaskClickCustomer({ rowData: rowData, rowId: rowId });
    setTableRowId(rowId);
    setIsTaskDrawerOpen(true);
  };

  const openSecondPopup = (taskId, customerId, refetchTaskData) => {
    let updatedtaskId;
    if (taskId) {
      updatedtaskId = {
        ...taskId,
        assigned_to:
          typeof taskId?.assigned_to === "object" ? taskId?.assigned_to : JSON.parse(taskId?.assigned_to || "{}"),
        start: { value: taskId?.start_date },
        end: { value: taskId?.end_date }, // Parse only if not an object
        tag: taskId?.tag?.map((item) => item.id),
      };
      setTaskId(updatedtaskId);
    } else {
      setTaskId(taskId);
    }

    setSecondPopupOpen({ customerId, refetchTaskData });
  };

  const TaskCompletionCheckbox = ({ isChecked }) => {
    return (
      <div
        className="flex items-center text-black cursor-pointer"
        // onClick={(e) => handleClickCompleted()}
      >
        <TaskRadioButton isChecked={isChecked} size="small" />
      </div>
    );
  };

  const TaskCard = ({ data, customerId, taskType, rowId }) => {
    const taskData = data?.task_date?.value;

    return (
      <div className="w-full">
        {/* top section */}
        <div className="px-3 py-2 w-full border-b-2">
          <div className="flex items-center justify-between rounded-[40px]">
            <div className="flex gap-2 items-center justify-center">
              <div
                className="flex items-center px-2 gap-2 py-1 rounded "
                style={{
                  backgroundColor: hexToRgba(TaskToDoConfig[taskType]?.color, 0.06),
                }}
              >
                <div style={{ color: TaskToDoConfig[taskType]?.color }}>{TaskToDoConfig[taskType]?.icon}</div>
                <div
                  className="font-poppins text-sm font-semibold leading-normal capitalize"
                  style={{ color: TaskToDoConfig[taskType]?.color }}
                >
                  {taskType.replace("_", " ")}
                </div>
              </div>
              <div className="h-5 min-w-5 w-fit px-1 py-1 flex items-center justify-center rounded-full bg-[#EE2727] text-white text-center text-xs">
                {taskData?.total_tasks}
              </div>
            </div>

            <div
              onClick={(e) => {
                handleTaskClick(data, taskType, rowId, e);
              }}
              className="cursor-pointer"
            >
              <ExpandIcon />
            </div>
          </div>
        </div>

        {/* bottom section */}
        <div className="w-full flex flex-col  ">
          {taskData?.tasks?.map((item, index) => {
            const nameArr = safeJsonParse(item?.assigned_to);

            return (
              <div
                key={index}
                // className={`${index == 0 ? "border-t-1 " : ""} cursor-pointer flex flex-col border-b border-dashed border-[#D2DAE1]  last:border-0 pt-2.5`}
                // style={
                //   index % 2 === 0
                //     ? { borderLeft: `4px solid ${hexToRgba(taskData?.status_color, 0.4)}` }
                //     : { borderRight: `4px solid ${hexToRgba(taskData?.status_color, 0.4)}` }
                // }

                className={`cursor-pointer flex flex-col border-b border-dashed border-[#D2DAE1] last:border-0 ${index === 0 ? "pt-1" : "pt-2.5"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  openSecondPopup(item, customerId);
                }}
              >
                <UniversalCardComponent
                  item={item}
                  nameArr={nameArr}
                  isSecondStyle
                  statusColorCustomer={taskData?.status_color}
                  // onClick={onClick}
                  // isTaskCompleted={isTaskCompleted}
                  TaskCompletionCheckbox={TaskCompletionCheckbox}
                  isCheckBoxShow
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const columns = useMemo(() => {
    const dynamicColumns =
      headerConfigData?.map((header, headerIndex) => ({
        accessorKey: header.value === "tasks" ? "task_date" : header.value,
        header: header.label, // Use label key for header
        meta: { position: "left", filterVariant: "select", type: header?.type, ...header?.meta },
        enableFiltering: false,
        // filterVariant: "select",

        filterFn: (row, columnId, filterValue) => filterColumn(row, columnId, filterValue, header.type),
        // ...(header.value === "delegation" ? { filterFn: jsonStringFilter } : { filterFn: multiSelectFilterFn }),
        // ...([].includes(header.value) && { enableColumnFilter: false }),
        enableColumnFilter: true,
        sortUndefined: "1", // Disable filtering by default
        cell: (info) => {
          const value = info.getValue();
          const data = info.row.original;
          const folderId = info.row.original?.folder_id || null;
          const core_id = info.row.original?.core_id || null;
          const row_id = info.row.original?.id || null;

          try {
            const parsedValue = safeJsonParse(value);
            console.log("parsedValue", header);
            if (header.value === "notes") {
              if (!info.row.original.id) return <div className="" onClick={(e) => e.stopPropagation()}></div>;
              return (
                <>
                  <div
                    className={`${info.row.original.id ? "cursor-pointer" : "cursor-not-allowed"} w-full`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (info.row.original.id) {
                        setIsNotesOpen(info.row.original.id);
                        setCustomerIdForCompanyLevel(core_id);
                      }
                    }}
                  >
                    <div className="flex items-center gap-1">
                      <ToolTipComponent text="View Notes" textOnly>
                        <DescriptionIcon className="cursor-pointer text-indigo-500" />
                      </ToolTipComponent>
                      {Number(parsedValue?.value) > 0 && (
                        <span style={{ fontSize: "12px", color: "#666" }}>({parsedValue?.value})</span>
                      )}
                    </div>
                  </div>
                </>
              );
            } else if (header.value === "created_at") {
              const data = info.row.original;
              return getUserDateTime(data?.created_at?.value);
            } else if (header.value === "updated_at") {
              return getUserDateTime(data?.updated_at?.value);
            } else if (header.type === "task_template") {
              const data = info.row.original;
              const key = header?.task_template_key;

              const { id: customerId, task_date: { value: tasks } = {} } = data;

              if (!tasks || !tasks?.tasks) {
                if (!info.row.original.id) return;
                return (
                  <div
                    onClick={(e) => {
                      if (!info.row.original.id) {
                        e.stopPropagation();
                      }
                    }}
                    className={`${info.row.original.id ? "cursor-pointer" : "cursor-not-allowed"} w-full flex justify-start delete-button`}
                  >
                    <ToolTipComponent disableInteractive text={<>Add Task</>}>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!info.row.original.id) {
                            e.stopPropagation();
                          } else {
                            setLeadTypeValue("task");
                            setTableRowId(info.row.original.id);
                            setTaskClickCustomer({
                              customer_name: data?.customer_name,
                              id: info.row.original.core_id,
                              data: data,
                            });
                            openSecondPopup(null, {
                              customer_name: data?.customer_name,
                              customer_id: info.row.original.core_id,
                            });
                          }
                        }}
                      >
                        <AddTask width="14px" height="14px" />
                        {Number(parsedValue?.value) > 0 && (
                          <span style={{ fontSize: "12px", color: "#666" }}>({parsedValue?.value})</span>
                        )}
                      </div>
                    </ToolTipComponent>
                  </div>
                );
              }

              const dateObj = new Date(tasks?.tasks[0]?.start_date);
              const formattedDate = dateObj.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
              });

              return (
                <>
                  <div className="flex items-center justify-between gap-1">
                    <ToolTipComponent
                      text={
                        <TaskCard data={data} customerId={customerIdForCompanyLevel} taskType={"task"} rowId={row_id} />
                      }
                      height="160px"
                      offset="right"
                      style={{ padding: "0px", width: "350px" }}
                    >
                      <p
                        className="px-2 py-1 rounded border min-w-[4rem] text-center"
                        style={{
                          borderRadius: "5px",
                          backgroundColor: hexToRgba(tasks?.status_color, 0.12),
                          color: tasks?.status_color,
                          border: "1px solid transparent",
                          boxShadow: `inset 0px 1px 0px 0px ${hexToRgba(tasks?.status_color, 0.8)}`,
                        }}
                      >
                        {formattedDate}
                      </p>
                    </ToolTipComponent>

                    <ToolTipComponent text="View Tasks" style={{ color: "#1D4469" }} textOnly>
                      <span
                        className="delete-button block"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTaskClick(info.row.original, "task", row_id, e);
                          setCustomerIdForCompanyLevel(core_id);
                        }}
                      >
                        <ViewTask width="14px" height="14px" />
                      </span>
                    </ToolTipComponent>
                  </div>
                </>
              );
            } else if (header?.type === "multi_person" || header?.type === "person") {
              return (
                <span className="flex items-center gap-2">
                  <p className="w-fit max-w-[10vw]">
                    <GetPersonAvatar
                      personList={parsedValue?.value}
                      header={header}
                      rowKey={info.row.original?.id}
                      isDetailsVisible={isDetailsVisible}
                      setDetailsVisible={setDetailsVisible}
                    />
                    {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                    {headerIndex == 0 && info.row.original.id && hasPermission && (
                      <span className="invisible group-hover:visible flex items-center gap-2">
                        {headerConfigDataRaw?.is_document && (
                          <CreateNewFolderIcon
                            className="cursor-pointer text-yellow-300"
                            onClick={(e) => {
                              setCustomerIdForCompanyLevel(core_id);
                              e.stopPropagation();
                              setIsDocumentOpen({
                                row_id: info.row.original.id,
                                template_id: containerId,
                                folderId: folderId,
                                customerId: core_id,
                              });
                            }}
                          />
                        )}

                        {/* {headerConfigDataRaw?.is_task && (
                          <AddTaskIcon
                            className="cursor-pointer text-green-500"
                            onClick={(e) => {
                              e.stopPropagation();
                              setTaskClickCustomer({ customer_name: data?.customer_name, id: customerId });
                              openSecondPopup(null, { customer_name: data?.customer_name, customer_id: customerId });
                              setTableRowId(info?.row?.original?.id);
                            }}
                          />
                        )} */}

                        {/* Expand (Edit) Icon */}
                        <NewExpandIcon
                          className="rotate-90 mr-2 cursor-pointer"
                          onClick={(e) => {
                            setCustomerIdForCompanyLevel(core_id);
                            e.stopPropagation();
                            handleEditRow(info?.row?.original);
                          }}
                        />

                        {/* Delete Icon */}
                        <DeleteIcon
                          className="text-red-500 cursor-pointer"
                          onClick={(e) => {
                            setCustomerIdForCompanyLevel(core_id);
                            e.stopPropagation();
                            setShowDeleteDialog({ id: info?.row?.original?.id });
                            // deleteSingleRowInTable([info.row.original.id]);
                          }}
                        />
                      </span>
                    )}
                  </p>
                </span>
              );
            } else if (header?.type === "text") {
              const { textSelectedOption } = header?.meta?.textFormat || {};
              return (
                <>
                  <span className="flex w-full gap-4 justify-between">
                    <HighlightedParagraph
                      paragraph={
                        textSelectedOption === "Hyperlink"
                          ? formatTextValue(parsedValue, textSelectedOption, true)
                          : formatTextValue(parsedValue?.value, textSelectedOption, false)
                      }
                      searchTerm={globalFilter}
                      className={"w-full"}
                    />

                    {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                    {headerIndex == 0 && info.row.original.id && hasPermission && (
                      <span className="invisible group-hover:visible flex items-center gap-2">
                        {headerConfigDataRaw?.is_document && (
                          <CreateNewFolderIcon
                            className="cursor-pointer text-yellow-300"
                            onClick={(e) => {
                              setCustomerIdForCompanyLevel(core_id);
                              e.stopPropagation();
                              setIsDocumentOpen({
                                row_id: info.row.original.id,
                                template_id: containerId,
                                folderId: folderId,
                                customerId: core_id,
                              });
                            }}
                          />
                        )}

                        {/* {headerConfigDataRaw?.is_task && (
                          <AddTaskIcon
                            className="cursor-pointer text-green-500"
                            onClick={(e) => {
                              e.stopPropagation();
                              setTaskClickCustomer({ customer_name: data?.customer_name, id: customerId });
                              openSecondPopup(null, { customer_name: data?.customer_name, customer_id: customerId });
                              setTableRowId(info?.row?.original?.id);
                            }}
                          />
                        )} */}

                        {/* Expand (Edit) Icon */}
                        <NewExpandIcon
                          className="rotate-90 mr-2 cursor-pointer"
                          onClick={(e) => {
                            // setCustomerIdForCompanyLevel(core_id);
                            e.stopPropagation();
                            // handleEditRow(info?.row?.original);
                            // setSelectedtableRowId(info?.row?.original?.id);
                            handleMultiViewRow(info?.row?.original);
                          }}
                        />

                        {/* Delete Icon */}
                        <DeleteIcon
                          className="text-red-500 cursor-pointer"
                          onClick={(e) => {
                            setCustomerIdForCompanyLevel(core_id);
                            e.stopPropagation();
                            setShowDeleteDialog({ id: info?.row?.original?.id });
                            // deleteSingleRowInTable([info.row.original.id]);
                          }}
                        />
                        {/* multi row view Icon */}
                        {/* <MultiRow
                          className="rotate-90 mr-2 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMultiViewRow(info?.row?.original);
                          }}
                        /> */}
                      </span>
                    )}
                  </span>
                </>
              );
            } else if (header?.type === "date") {
              return (
                <>
                  <HighlightedParagraph className={"w-full"} paragraph={parsedValue?.value} searchTerm={globalFilter} />
                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && hasPermission && (
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {headerConfigDataRaw?.is_document && (
                        <CreateNewFolderIcon
                          className="cursor-pointer text-yellow-300"
                          onClick={(e) => {
                            setCustomerIdForCompanyLevel(core_id);
                            e.stopPropagation();
                            setIsDocumentOpen({
                              row_id: info.row.original.id,
                              template_id: containerId,
                              folderId: folderId,
                              customerId: core_id,
                            });
                          }}
                        />
                      )}

                      {/* {headerConfigDataRaw?.is_task && (
                        <AddTaskIcon
                          className="cursor-pointer text-green-500"
                          onClick={(e) => {
                            e.stopPropagation();
                            setTaskClickCustomer({ customer_name: data?.customer_name, id: customerId });
                            openSecondPopup(null, { customer_name: data?.customer_name, customer_id: customerId });
                            setTableRowId(info?.row?.original?.id);
                          }}
                        />
                      )} */}

                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          setCustomerIdForCompanyLevel(core_id);
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          setCustomerIdForCompanyLevel(core_id);
                          e.stopPropagation();
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                          // deleteSingleRowInTable([info.row.original.id]);
                        }}
                      />
                    </span>
                  )}
                </>
              );
            } else if (header?.type === "number") {
              return (
                <>
                  <HighlightedParagraph
                    paragraph={
                      header?.meta
                        ? formatNegativeNumber(
                            parsedValue?.value,
                            header?.meta?.numberFormat?.negativeFormat,
                            header?.meta?.absoluteType,
                            header?.meta?.numberFormat?.decimalPlaces,
                            header?.meta?.numberFormat?.separators,
                            header?.meta?.numberFormat?.symbol
                          )
                        : parsedValue?.value?.value || parsedValue?.value
                    }
                    className={"w-full"}
                    searchTerm={globalFilter}
                  />

                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && hasPermission && (
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {headerConfigDataRaw?.is_document && (
                        <CreateNewFolderIcon
                          className="cursor-pointer text-yellow-300"
                          onClick={(e) => {
                            setCustomerIdForCompanyLevel(core_id);
                            e.stopPropagation();
                            setIsDocumentOpen({
                              row_id: info.row.original.id,
                              template_id: containerId,
                              folderId: folderId,
                              customerId: core_id,
                            });
                          }}
                        />
                      )}

                      {/* {headerConfigDataRaw?.is_task && (
                        <AddTaskIcon
                          className="cursor-pointer text-green-500"
                          onClick={(e) => {
                            e.stopPropagation();
                            setTaskClickCustomer({ customer_name: data?.customer_name, id: customerId });
                            openSecondPopup(null, { customer_name: data?.customer_name, customer_id: customerId });
                            setTableRowId(info?.row?.original?.id);
                          }}
                        />
                      )} */}
                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          setCustomerIdForCompanyLevel(core_id);
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          setCustomerIdForCompanyLevel(core_id);
                          e.stopPropagation();
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                          // deleteSingleRowInTable([info.row.original.id]);
                        }}
                      />
                    </span>
                  )}
                </>
              );
            } else if (Array.isArray(parsedValue?.value) && parsedValue?.value?.length > 0) {
              return <ResponsiveTags parsedValue={parsedValue?.value} />;
            } else if (typeof parsedValue?.value === "object") {
              const hexColor =
                parsedValue?.color || parsedValue?.value?.color || parsedValue?.code
                  ? `${parsedValue?.color || parsedValue?.value?.color || parsedValue?.color}`
                  : undefined;
              return (
                <div
                  className={`${hexColor && "px-2 py-1"} group rounded min-w-full max-w-[10vw] text-ellipsis overflow-hidden flex justify-between items-center`}
                  style={{
                    backgroundColor: hexColor && getHexWithOpacity(hexColor, 10),
                    // backgroundColor:getHexWithOpacity('#000000', 40),
                    color: hexColor ? hexColor : "black",
                    borderRadius: "5px",
                    border: hexColor ? `0.8px solid ${hexColor}` : "none",
                  }}
                >
                  {parsedValue?.value?.value || <p>{parsedValue?.value}</p>}

                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && hasPermission && (
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {headerConfigDataRaw?.is_document && (
                        <CreateNewFolderIcon
                          className="cursor-pointer text-yellow-300"
                          onClick={(e) => {
                            setCustomerIdForCompanyLevel(core_id);
                            e.stopPropagation();
                            setIsDocumentOpen({
                              row_id: info.row.original.id,
                              template_id: containerId,
                              folderId: folderId,
                              customerId: core_id,
                            });
                          }}
                        />
                      )}

                      {/* {headerConfigDataRaw?.is_task && (
                        <AddTaskIcon
                          className="cursor-pointer text-green-500"
                          onClick={(e) => {
                            e.stopPropagation();
                            setTaskClickCustomer({ customer_name: data?.customer_name, id: customerId });
                            openSecondPopup(null, { customer_name: data?.customer_name, customer_id: customerId });
                            setTableRowId(info?.row?.original?.id);
                          }}
                        />
                      )} */}

                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          setCustomerIdForCompanyLevel(core_id);
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          setCustomerIdForCompanyLevel(core_id);
                          e.stopPropagation();
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                          // deleteSingleRowInTable([info.row.original.id]);
                        }}
                      />
                    </span>
                  )}
                </div>
              );
            } else {
              return (
                <div
                  className={`py-1 rounded min-w-full max-w-[10vw] text-ellipsis overflow-hidden flex justify-between`}
                >
                  {parsedValue?.value || <p></p>}

                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY AND AVOID ADDING ON LAST COLUMN */}
                  {headerIndex == 0 && info.row.original.id && hasPermission && (
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {headerConfigDataRaw?.is_document && (
                        <CreateNewFolderIcon
                          className="cursor-pointer text-yellow-300"
                          onClick={(e) => {
                            setCustomerIdForCompanyLevel(core_id);
                            e.stopPropagation();
                            setIsDocumentOpen({
                              row_id: info.row.original.id,
                              template_id: containerId,
                              folderId: folderId,
                              customerId: core_id,
                            });
                          }}
                        />
                      )}

                      {/* {headerConfigDataRaw?.is_task && (
                        <AddTaskIcon
                          className="cursor-pointer text-green-500"
                          onClick={(e) => {
                            e.stopPropagation();
                            setTaskClickCustomer({ customer_name: data?.customer_name, id: customerId });
                            openSecondPopup(null, { customer_name: data?.customer_name, customer_id: customerId });
                            setTableRowId(info?.row?.original?.id);
                          }}
                        />
                      )} */}

                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          setCustomerIdForCompanyLevel(core_id);
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          setCustomerIdForCompanyLevel(core_id);
                          e.stopPropagation();
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                          // deleteSingleRowInTable([info.row.original.id]);
                        }}
                      />
                    </span>
                  )}
                </div>
              );
            }
          } catch (error) {}
          return (
            <HighlightedParagraph
              paragraph={<p className="w-fit max-w-[10vw] text-ellipsis overflow-hidden ">{JSON.stringify(value)}</p>}
              searchTerm={globalFilter}
              className={"w-full"}
            />
          );
        },
      })) || [];

    const staticColumn = [
      // ...(grouping.length === 0
      //   ? [
      //       {
      //         id: "select",
      //         header: ({ table }) => {
      //           const allRows = table.getRowModel().rows;
      //           const allRowIds = allRows.map((row) => row.original.id);
      //           const allSelected = allRowIds?.every((id) => multiData[id]);
      //           const someSelected = allRowIds?.some((id) => multiData[id]);
      //           return (
      //             <IndeterminateCheckbox
      //               {...{
      //                 checked: allSelected,
      //                 indeterminate: someSelected && !allSelected,
      //                 onChange: (e) => {
      //                   if (e.target.checked) {
      //                     setLastSelectedRowIndex(null);
      //                     setMultiData((prev) => ({
      //                       ...prev,
      //                       ...Object.fromEntries(allRowIds.map((id) => [id, true])),
      //                     }));
      //                   } else {
      //                     setLastSelectedRowIndex(null);
      //                     setMultiData((prev) => {
      //                       const updated = { ...prev };
      //                       allRowIds.forEach((id) => delete updated[id]);
      //                       return updated;
      //                     });
      //                   }
      //                 },
      //               }}
      //             />
      //           );
      //         },
      //         cell: ({ row, table }) => {
      //           return (
      //             <div className="">
      //               {row?.original?.id && (
      //                 <IndeterminateCheckbox
      //                   {...{
      //                     checked: multiData[row.original.id],
      //                     disabled: !row.getCanSelect(),
      //                     indeterminate: row.getIsSomeSelected(),
      //                     onClick: (e) => handleRowSelection(e, row.original.id, row.index, table),
      //                   }}
      //                 />
      //               )}
      //             </div>
      //           );
      //         },
      //       },
      //     ]
      //   : []),
      // {
      //   id: "groupedColumn",
      //   header: ({ table }) =>
      //     grouping.length > 1
      //       ? "Group"
      //       : table
      //           .getAllColumns()
      //           .filter((col) => col.columnDef.accessorKey === grouping[0])
      //           .map((col) => col.columnDef.header)[0] || grouping[0],
      //   cell: () => null,
      // },
    ];

    // If columns are not created.
    if (headerConfigData?.length > 0) {
      return [...staticColumn, ...dynamicColumns];
    }
    return null;
  }, [headerConfigData, multiData, globalFilter]);

  useEffect(() => {
    if (!isCompanyLevel) {
      setCustomerIdForCompanyLevel(customerId);
    }
  }, [customerId]);

  const memoizedCustomerData = useMemo(() => {
    // if (globalFilter?.length > 0) {
    // }
    return mySpaceBody;
  }, [mySpaceBody, headerConfigData, globalFilter]);

  const [{ data: customerTableALL, isLoading: customerListLoading, isFetching: customerListFetching }] =
    useFetchCustomerTableDataNewMutation();

  const handleBulkFieldUpdateList = async ({ tableId, fieldId, rowsIds, value }) => {
    try {
      const response = await mySpaceTableBulkUpdateListValue({
        params: { tableId: tableId },
        body: {
          fieldId: fieldId,
          rowIds: rowsIds,
          data: { value },
        },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleTableFieldUpdate = async (item, field_name, cell) => {
    try {
      const columnInfo = headerConfigData?.find((header) => header?.value === cell?.column?.id);
      const row_id = cell?.row?.original?.id || "";

      // "data" consist directly the main value.
      let data = item;

      if (columnInfo?.meta?.absoluteType === "hyperlink") {
        data = { textForUrl: item?.textForUrl, url: item?.url };
      }

      if (columnInfo?.type === "dropdown") {
        data = item?.id;
      }

      if (columnInfo?.type === "multiselect") {
        data = item?.map((data) => data?.id);
      }

      const checkBoxSelectedIds = Object.keys(multiData).filter((info) => {
        return !isNaN(Number(info));
      });

      if (checkBoxSelectedIds?.length > 0) {
        await handleBulkFieldUpdateList({
          tableId: containerId,
          fieldId: columnInfo?.id,
          rowsIds: checkBoxSelectedIds,
          value: data,
        });
        return;
      }

      let body = {
        // row_id: row_id,
        core_id: customerIdForCompanyLevel,
        field_id: columnInfo?.id,
        row_id: row_id,
        value: data,
      };

      const response = await addUpdateFieldValue({ body, query: { key: "u2_core", template_id: containerId } });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );

        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleSingleUpdateField = async ({ fieldValue, column_info, row_id }) => {
    try {
      const columnInfo = headerConfigData?.find((header) => header?.value === column_info?.key);

      // "data" consist directly the main value.
      let data = fieldValue;

      if (columnInfo?.meta?.absoluteType === "hyperlink") {
        data = { textForUrl: fieldValue?.textForUrl, url: fieldValue?.url };
      }

      if (columnInfo?.type === "dropdown") {
        data = fieldValue?.id;
      }

      if (columnInfo?.type === "multiselect") {
        data = fieldValue?.map((data) => data?.id);
      }

      const checkBoxSelectedIds = Object.keys(multiData).filter((info) => {
        return !isNaN(Number(info));
      });

      if (checkBoxSelectedIds?.length > 0) {
        await handleBulkFieldUpdateList({
          tableId: containerId,
          fieldId: columnInfo?.id,
          rowsIds: checkBoxSelectedIds,
          value: data,
        });
        return;
      }

      let body = {
        // row_id: row_id,
        core_id: customerIdForCompanyLevel || null,
        field_id: columnInfo?.id,
        row_id: row_id,
        value: data,
      };

      const response = await addUpdateFieldValue({ body, query: { key: "u2_core", template_id: containerId } });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );

        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  // CRAETE COLUMN IN MY SPACE
  const handleAddTableColumn = async (fielddata) => {
    try {
      const body = {
        field_label: fielddata?.field_label,
        field_type: fielddata?.field_type,
        description: fielddata?.field_description,
        meta: fielddata?.meta || null,
      };

      if (
        fielddata?.field_type?.toLowerCase() === "dropdown" ||
        fielddata?.field_type?.toLowerCase() === "multiselect"
      ) {
        body.dropdown_options = fielddata?.field_options.map((data) => ({
          value: data?.value,
          color: data?.color_code,
        }));
      }

      const params = {
        tableId: containerId,
      };

      const response = await addUpdateHeader({ body });

      if (response?.success || response?.status) {
        const createdNewColumnId = response?.data?.id;

        // if (fielddata?.field_type === "dropdown") {
        //   await handleAddColumnOptions(fielddata, createdNewColumnId);
        // }
        await fetchMySpaceHeaderConfig(containerId);
        setExtraField((prev) => !prev);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleUpdateTableColumn = async (fieldData) => {
    try {
      // const params = {
      //   tableId: containerId,
      //   fieldId: fieldData?.fieldId,
      // };
      let body = {
        id: fieldData?.fieldId,
        field_label: fieldData?.field_label,
        // field_type: fieldData?.field_type,
        description: fieldData?.field_description,
      };

      if (fieldData?.field_type === "number") {
        const { negativeFormat, selectedOption, decimalPlaces, separators, symbol } =
          fieldData?.meta?.numberFormat || {};

        let newSeparators = separators;
        let newSymbol = symbol;

        switch (selectedOption) {
          case "Number":
            newSymbol = false;
            break;
          case "Percentage":
            newSeparators = false;
            newSymbol = false;
            break;
          // For "Currency", use default values (no change)
        }

        body = {
          ...fieldData,
          meta: {
            numberFormat: {
              negativeFormat,
              selectedOption,
              decimalPlaces,
              separators: newSeparators,
              symbol: newSymbol,
            },
          },
        };
      } else if (fieldData?.field_type === "dropdown" || fieldData?.field_type === "multiselect") {
        body = {
          ...body,
          dropdown_options: fieldData?.field_options?.map((option) => {
            return {
              value: option?.value,
              color: option?.color_code,
            };
          }),
        };
      }
      const response = await addUpdateHeader({ body: body });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );

        await fetchMySpaceHeaderConfig(containerId);
        setExtraField((prev) => !prev);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleDeleteTableColumnOption = async (fieldId, optionId) => {
    try {
      const response = await deleteFieldOption({
        params: {
          // fieldId: fieldId,
          optionId: optionId,
        },
      });
      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );

        let columnInfo = headerConfigData.find((item) => item?.id === fieldId) || null;

        const fieldOptionsResponse = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        const formatedOptionsResponse = fieldOptionsResponse?.data?.map((data) => {
          return {
            value: data?.label,
            color_code: data?.color,
            uuid: data?.id,
            field_id: fieldId,
          };
        });
        setIsEditableFieldModeActive((prev) => ({
          ...prev,
          field_options: formatedOptionsResponse,
        }));
        // await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleAddColumnOptions = async (fielddata, createdNewColumnId) => {
    try {
      const body = {
        option: fielddata?.field_options?.map((item) => {
          return {
            value: item?.value,
            color: item?.color_code,
          };
        }),
      };

      const response = await mySpaceAddColumnOptions({ body, params: { tableColumnId: createdNewColumnId } });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEditColumn = async (columnId) => {
    headerConfigData.map(async (item) => {
      if (item?.value === columnId?.id) {
        let optionsFormat = {
          field_name: item?.value,
          field_label: item?.label,
          field_options: [],
          field_type: item?.type,
          field_description: "",
          id: item?.id,
          selectedOption: INPUT_LIST?.find((input) => input?.inputType === item?.meta?.absoluteType)?.inputName,
        };

        if (item?.type === "dropdown" || item?.type === "multiselect") {
          const fieldOptionsResponse = await fetchColumnDropdownOptions({ query: { field_name: item?.value } });
          const formatedOptionsResponse = fieldOptionsResponse?.data?.map((data) => {
            return {
              value: data?.label,
              color_code: data?.color,
              uuid: data?.id,
              field_id: item?.id,
            };
          });
          optionsFormat.field_options = formatedOptionsResponse;
        } else if (item?.type === "number") {
          Object.keys(item?.meta?.numberFormat)?.forEach((data) => {
            optionsFormat = { ...optionsFormat, [data]: item?.meta?.numberFormat[data] };
          });
        }

        setIsEditableFieldModeActive(optionsFormat);
      }
    });
    setExtraField(true);
  };

  const handleDeleteColumn = async (columnId) => {
    try {
      let column_id;
      headerConfigData.forEach(async (item) => {
        if (item?.value === columnId?.id) {
          column_id = item?.id;
        }
      });

      const response = await deleteColumn({
        params: { fieldId: column_id },
      });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const cursorloader = customerListFetching || customerListFetching || customerListLoading;

  function convertFormatForSingleHeader(apiResponse) {
    if (!apiResponse?.data?.length) return [];

    // define which types to skip
    // const skipTypes = ["task_template", "note_template"];
    const skipTypes = [];

    return apiResponse.data.flatMap((section) => {
      const sectionName = section.title || "";
      const fields = section.fields || [];

      return fields
        .filter((field) => !skipTypes.includes(field.type)) // skip unwanted types
        .map((field) => {
          const { id, value, label, type, meta, is_editable, is_visible } = field;
          const absoluteType = meta?.absoluteType || type || "text";

          const normalizeNumberFormat = (nf) =>
            nf
              ? {
                  symbol: nf.symbol || false,
                  separators: !!nf.separators,
                  decimalPlaces: typeof nf.decimalPlaces === "number" ? nf.decimalPlaces : null,
                  negativeFormat: nf.negativeFormat || "minus",
                  selectedOption:
                    meta?.textFormat?.textSelectedOption ||
                    absoluteType?.charAt(0).toUpperCase() + absoluteType?.slice(1),
                }
              : null;

          const mappedMeta =
            meta && Object.keys(meta).length
              ? {
                  textFormat: meta.textFormat || {},
                  numberFormat: normalizeNumberFormat(meta.numberFormat),
                  dateTimeFormat: meta.dateTimeFormat || {},
                }
              : null;

          let finalType = type;
          if (absoluteType === "person" && !type) {
            finalType = value?.includes("multi") || label?.toLowerCase().includes("multi") ? "multi_person" : "person";
          }

          return {
            key: value || id,
            field_id: id,
            label,
            statuslabel: "0",
            value: value || "",
            type: finalType || "text",
            meta: mappedMeta,
            visibility: true,
            is_visible: is_visible || true,
            sectionName,
          };
        });
    });
  }

  const handleFetchDropdownOptions = async ({ fieldName }) => {
    try {
      const response = await fetchColumnDropdownOptions({ query: { field_name: fieldName } });
      if (response?.success || response?.status) {
        setDropdownOptionsData(
          response?.data?.map((option) => ({ id: option?.id, value: option?.label, color_code: option?.color }))
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message || "Something went wrong",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  function convertToVisibilityMap(fields) {
    const result = {};
    for (const field of fields) {
      if (field.is_visible === true) {
        result[field.value] = true;
      }
    }
    return result;
  }

  // FETCH MY SPACE TABLE HEADERS
  const fetchMySpaceHeaderConfig = async (containerId) => {
    try {
      setIsApiLoading(true);
      const response = await fetchHeaders({
        query: { template_id: containerId, ...(isCompanyLevel && { is_company_level: true }) },
      });
      if (response?.success || response?.status) {
        setHeaderConfigDataRaw(response);
        let extractOnlyColumns = [];
        response?.data?.forEach((columnInfo) => {
          extractOnlyColumns = [
            ...extractOnlyColumns,
            ...(columnInfo?.fields?.map((columnData) => ({ ...columnData, sectionName: columnInfo?.title })) || []),
          ];
        });

        const formatted = convertFormatForSingleHeader(response);
        setHeaderSingleFormat(formatted);

        setSubModulesItems(response?.items || []);

        // -------------

        const fitlerColumn = convertToVisibilityMap(formatted);
        const columnOrder = Object.keys(fitlerColumn).filter((key) => fitlerColumn[key] === true);

        const field_visibility = response?.meta?.field_management?.field_visibility?.[0];
        const field_order = response?.meta?.field_management?.field_order;

        let tempFieldOrder = [];
        let tempFieldVisibility = {};

        // Add new fields
        Object.keys(fitlerColumn).forEach((key) => {
          if (field_visibility && !field_visibility.hasOwnProperty(key)) {
            tempFieldOrder.push(key);
            tempFieldVisibility[key] = true;
          }
        });

        console.log("harsh fitlerColumn", fitlerColumn, formatted);

        if (field_visibility || field_order) {
          // Remove fields that no longer exist in fitlerColumn
          const filteredVisibility = Object.fromEntries(
            Object.entries(field_visibility || {}).filter(([key]) => key in fitlerColumn)
          );
          const filteredOrder = (field_order || []).filter((key) => key in fitlerColumn);

          // Merge existing + new (additions only)
          setColumnVisibility({ ...filteredVisibility, ...tempFieldVisibility });
          setColumnOrder([...filteredOrder, ...tempFieldOrder]);
        } else {
          if (fitlerColumn) {
            setColumnVisibility(fitlerColumn);
            setColumnOrder(columnOrder);
          }
        }
        // -------------

        setHeaderConfigData(extractOnlyColumns);
        // const breadcrumpList = response?.path?.map((data) => {
        //   // Only root folder will be considered as container. so is Null
        //   return {
        //     label: data?.folderName,
        //     id: data?.folderId,
        //     isContainer: data?.folderId ? true : false,
        //   };
        // });
        // setBreadcrumpList(breadcrumpList || [{ label: "My Space", id: null, isContainer: true }]);
        // Defining visibility of columns based on response and previous state.
        // handleManageDrawerData(extractOnlyColumns);
        await fetchMySpaceTableBodyData(containerId, extractOnlyColumns, response?.only_company_level);
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  // const handleManageDrawerData = (headerData) => {
  //   setColumnVisibility((prev) => {
  //     const allHeaderColumnsValue = headerData?.map((object) => object.value) || [];

  //     // Filter out fields that are not present in header data
  //     const newVisibleFields = prev?.visible_fields?.filter((value) => allHeaderColumnsValue.includes(value)) || [];
  //     const newHiddenFields = prev?.hidden_fields?.filter((value) => allHeaderColumnsValue.includes(value)) || [];

  //     // Find fields in headerData that are not in either visible or hidden, and add them to visible
  //     const missingFields = allHeaderColumnsValue.filter(
  //       (value) => !newVisibleFields.includes(value) && !newHiddenFields.includes(value)
  //     );

  //     return {
  //       ...prev,
  //       visible_fields: [...newVisibleFields, ...missingFields],
  //       hidden_fields: newHiddenFields,
  //     };
  //   });
  // };

  function convertCustomerDataFormat(apiResponse) {
    if (!apiResponse?.data?.length) return [];

    return apiResponse.data.map((item) => {
      const result = {};
      const flatData = item.data || {};

      for (const [key, valObj] of Object.entries(flatData)) {
        let value = valObj?.value ?? null;

        // if value is array or object -> don't stringify
        if (Array.isArray(value) || (value && typeof value === "object")) {
          result[key] = { value };
        } else if (typeof value === "string" && (value.trim().startsWith("{") || value.trim().startsWith("["))) {
          // attempt to parse JSON-like strings
          try {
            result[key] = { value: JSON.parse(value) };
          } catch {
            result[key] = { value };
          }
        } else {
          result[key] = { value };
        }
      }

      // keep structural identifiers
      result.row_id = item.row_id || null;
      result.core_id = item.core_id || null;
      result.folder_id = item.folder_id || null;

      return result;
    });
  }

  function getHiddenFields(obj) {
    const hidden_fields = [];

    for (const [key, value] of Object.entries(obj)) {
      if (value !== true) hidden_fields.push(key);
      else;
    }

    return hidden_fields;
  }

  const fetchMySpaceTableBodyData = async (tableId, headerData, only_company_level) => {
    try {
      const response = await fetchHeaderValues({
        query: { template_id: tableId, ...(!isCompanyLevel && { core_id: customerIdForCompanyLevel ?? customerId }) },
      });

      if (response?.success || response?.status) {
        // Factory for a fresh empty-entry based on headers
        const makeEmpty = () => createEmptyEntry(headerData);
        console.log("harsh vv", makeEmpty());

        // Pull out and flatten each row’s entire data object
        const existingEntries = response.data.map((item) => ({
          ...item.data,
          id: item?.row_id,
          folder_id: item?.folder_id || null,
          core_id: item?.core_id || null,
        }));

        const formatted = convertCustomerDataFormat(response);
        setHeaderBodyFormat(formatted);

        setMySpaceBodyDataRaw({ success: true, data: existingEntries });

        // Merge defaults (empty) with actual data, ensuring all keys exist
        const filledEntries = existingEntries.map((dataObj) => ({
          ...makeEmpty(),
          ...dataObj,
        }));

        if (headerData?.length >= 0) {
          if (isCompanyLevel && !only_company_level) {
            setMySpaceBodyData([...filledEntries]);
          } else {
            // Set state: all filled rows + one completely blank row at the end
            setMySpaceBodyData([...filledEntries, makeEmpty()]);
          }
        }
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response.data?.message || "Something Went Wrong.",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const createEmptyEntry = (headerData) => {
    // Mapping through header data to create empty entry
    try {
      const emptyEntry = {};
      headerData?.forEach((header) => {
        emptyEntry[header?.value] = null;
      });
      return emptyEntry;
    } catch (error) {}
  };

  const deleteBulkRowsInTable = async () => {
    try {
      const checkBoxSelectedIds = Object.keys(multiData).filter((info) => {
        return !isNaN(Number(info));
      });
      const response = await mySpaceTableRowDelete({
        params: { tableId: containerId },
        body: {
          rowIds: checkBoxSelectedIds ?? [],
        },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        setMultiData({});
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };
  const deleteSingleRowInTable = async (idsToBeDelete = null) => {
    try {
      const response = await deleteRow({
        params: { rowId: idsToBeDelete[0], template_id: containerId, key: "u2_core" },
        // body: {
        //   rowIds: idsToBeDelete ?? [],
        // },
      });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        setMultiData({});
        setShowDeleteDialog(false);
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const isMySpaceCreateColumnHtml = () => {
    return (
      <div className="w-full h-full bg-gray-100 flex justify-center items-center">
        <div className="w-full h-full flex flex-col justify-center items-center">
          <CustomModuleEmptySvg />
          <p className="mt-4 text-gray-600">Currently, no manage list available.</p>
          {/* {(!isCompanyLevel || headerConfigDataRaw?.only_company_level) && (
            <button
              onClick={() => {
                handleAddRow();
                setSelectedtableRowId(null);
                setIsActiveAddItem(true);
              }}
              className="group flex items-center  py-1  rounded text-gray-600 border border-transparent hover:border-[#004EFF] transition-colors duration-200"
            >
              <AddItemPlus />
            </button>
          )} */}
        </div>
      </div>
    );
  };

  // const handleFieldVisibility = (data) => {
  //   setColumnVisibility((prev) => {
  //     if (prev.hidden_fields.includes(data)) {
  //       prev.hidden_fields?.splice(prev.hidden_fields?.indexOf(data), 1);
  //       return {
  //         visible_fields: [...prev.visible_fields, data],
  //         hidden_fields: [...prev.hidden_fields],
  //       };
  //     } else {
  //       if (prev.visible_fields?.includes(data)) {
  //         prev.visible_fields?.splice(prev.visible_fields?.indexOf(data), 1);
  //       }
  //       return {
  //         visible_fields: [...prev.visible_fields],
  //         hidden_fields: [...prev.hidden_fields, data],
  //       };
  //     }
  //   });

  //   setMySpaceVisibleFields(containerId, {
  //     visible_fields: columnVisibility.visible_fields,
  //     hidden_fields: columnVisibility.hidden_fields,
  //   });
  // };

  function reorderArray(arr, sourceIndex, targetIndex) {
    // Make a shallow copy
    const newArr = [...arr];

    // Handle invalid indices
    if (sourceIndex < 0 || targetIndex < 0 || sourceIndex >= newArr.length || targetIndex >= newArr.length) {
      return newArr;
    }

    // Move the element
    const [moved] = newArr.splice(sourceIndex, 1);
    newArr.splice(targetIndex, 0, moved);

    return newArr; // ✅ returns an array of strings
  }

  const handleReorderFields = (sourceIndex, targetIndex) => {
    const reOrderingColumn = reorderArray(columnOrder, sourceIndex, targetIndex);
    if (reOrderingColumn) {
      setColumnOrder(reOrderingColumn);
    }
  };

  function toggleVisibility(obj, key) {
    if (!(key in obj)) return obj; // no change if key missing

    // Toggle the value
    const updated = { ...obj, [key]: !obj[key] };

    // Sort keys so true values come first
    const sortedEntries = Object.entries(updated).sort(([, aVal], [, bVal]) => {
      return (bVal === true) - (aVal === true); // true before false
    });

    // Rebuild object in sorted order
    return Object.fromEntries(sortedEntries);
  }

  const handleFieldVisibility = (fieldName) => {
    const visibilty = toggleVisibility(columnVisibility || {}, fieldName);
    setColumnVisibility(visibilty);
    setColumnOrder(Object.keys(visibilty).filter((key) => visibilty[key] === true));
  };
  const [PostMetaData] = usePostApiMutation();

  const handlePostMeta = () => {
    PostMetaData({
      url: `${NODE_URL_V2}global/${containerId}/meta?is_company_level=${isCompanyLevel ? "true" : "false"}`,
      data: {
        field_management: {
          field_visibility: [columnVisibility],
          field_order: columnOrder,
        },
      },
    });
    setIsManageFieldOpen(false);
  };

  // Notes Modal ----------------------------------------------------------------
  const [isNotesOpen, setIsNotesOpen] = useState(false);

  const handleCloseNotes = () => {
    setIsNotesOpen(false);
  };

  const handleNotesDataRefetch = () => {
    fetchMySpaceHeaderConfig(containerId);
  };
  const handleSingleAddRecord = async () => {
    // Finding column type
    let rowData = [];
    for (let columnInfo of headerConfigData) {
      let columnDropdownOptions = [];
      let columnMetaType = null;

      if (columnInfo?.label === "Task") {
        continue;
      } else if (columnInfo?.label === "Notes") {
        continue;
      }

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        if (!response?.success && !response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.label,
            color_code: data?.color,
          };
        });
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });
      } else if (columnInfo?.type === "text") {
        // if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
        columnMetaType = columnInfo?.meta?.textFormat?.textSelectedOption;
        // }
      } else if (columnInfo?.type === "date") {
        if (columnInfo?.meta?.absoluteType === "date") {
          columnMetaType = "Date";
        } else {
          columnMetaType = "DateTime";
        }
      }

      if (mySpaceBodyRaw?.data?.[0]) {
        rowData.push({
          name: columnInfo?.label || null,
          value: mySpaceBodyRaw?.data?.[0]?.[columnInfo?.value]?.value || null,
          type: columnInfo?.type || null,
          options: columnDropdownOptions || null,
          id: columnInfo?.id || null,
          columnMetaType: columnMetaType || null,
          is_editable: columnInfo?.is_editable,
          sectionName: columnInfo?.sectionName,
          row_id: mySpaceBodyRaw?.data?.[0]?.id,
        });
      } else {
        rowData.push({
          name: columnInfo?.label || null,
          value: null, // Initial value defined for text and value and updatingit later for dropdown/multiselect
          type: columnInfo?.type || null,
          options: columnDropdownOptions || null,
          id: columnInfo?.id || null,
          columnMetaType: columnMetaType || null,
          is_editable: columnInfo?.is_editable,
          sectionName: columnInfo?.sectionName,
          row_id: null,
        });
      }
    }

    setShowSingleForm({ show: true, data: rowData });
  };

  const handleSingleEditRow = async (rowInfo = {}) => {
    const rowData = [];
    let columnMetaType;
    let columnLabel;
    for (let columnName of Object.keys(rowInfo)) {
      columnLabel = headerConfigData.find((item) => item?.value === columnName)?.label || columnName;
      columnMetaType = null;
      // TODO - CUSTOMER TABLE IS HAVING UNNECESSARY ID COLUMN...
      if (columnName === "id") {
        continue;
      }
      if (columnName === "folder_id") {
        continue;
      }

      // Finding column type
      let columnInfo = headerConfigData.find((item) => item?.value === columnName) || null;
      let columnDropdownOptions = [];

      // Initial value defined for text and value and updatingit later for dropdown/multiselect
      let columnValue = rowInfo[columnName]?.value;

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        if (!response?.success && !response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.label,
            color_code: data?.color,
          };
        });

        if (columnInfo?.type === "dropdown") {
          if (rowInfo[columnName]?.value?.id) {
            columnValue = [
              {
                value: rowInfo[columnName]?.value?.id,
                label: rowInfo[columnName]?.value?.value,
                color_code: rowInfo[columnName]?.value?.color,
              },
            ];
          } else {
            columnValue = [];
          }
        } else {
          if ((columnValue = rowInfo[columnName]?.value)) {
            columnValue = rowInfo[columnName]?.value?.map((cellOption) => {
              return {
                value: cellOption?.id,
                label: cellOption?.value,
                color_code: cellOption?.color,
              };
            });
          } else {
            columnValue = [];
          }
        }
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });

        columnValue = rowInfo[columnName]?.value?.map((cellOption) => {
          return {
            id: cellOption?.id,
            value: cellOption?.uuid,
            label: cellOption?.name,
            subLabel: cellOption?.email,
          };
        });
      } else if (columnInfo?.type === "text") {
        if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
          columnMetaType = columnInfo?.meta?.textFormat?.textSelectedOption;
        }
      } else if (columnInfo?.type === "date") {
        if (columnInfo?.meta?.absoluteType === "date") {
          columnMetaType = "Date";
        } else {
          columnMetaType = "DateTime";
        }
      }

      rowData.push({
        name: columnLabel || null,
        value: columnValue || null,
        type: columnInfo?.type || null,
        options: columnDropdownOptions || null,
        id: columnInfo?.id || null,
        columnMetaType: columnMetaType || null,
        row_id: rowInfo.id,
        sectionName: columnInfo?.sectionName,
        is_editable: columnInfo?.is_editable,
      });
    }

    setShowAddEditModal({ show: true, data: rowData });
    // setShowSingleForm({ show: true, data: rowData });
    setRowAddEditMode("edit");
  };

  // Notes Modal -----------------------------------------------------------------

  // DOCUMENT UPLOAD MODAL -------------------------------------------------------

  // DOCUMENT UPLOAD MODAL -------------------------------------------------------

  useEffect(() => {
    // Subtracting to total count to remove empty entry at the last.
    setTotalCount(mySpaceBody?.length - 1);
  }, [mySpaceBody]);

  // When click on file, the headerAPI will be called and update the table content.
  useEffect(() => {
    if (containerId) {
      fetchMySpaceHeaderConfig(containerId);
      console.log("harsh useEffect called");
    }
  }, [containerId]);

  useEffect(() => {
    setContainerId(propTemplateId || templateId);
  }, [propTemplateId, templateId]);

  useEffect(() => {
    if (isApiLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isApiLoading]);

  useEffect(() => {
    if (customerTableALL) {
      setMultiData({});
    }
  }, [customerTableALL]);

  useEffect(() => {
    if (location.key) {
      dispatch(getUserTokeData());
    }
  }, [location.key]);

  useEffect(() => {
    if (!isManageFieldOpen) {
      setIsMangeHovered(false);
    }
  }, [isManageFieldOpen]);

  // useEffect(() => {
  //   if (containerId) {
  //     const columnOrderLocalState = getMySpaceColumnOrder(containerId);
  //     const visibleFieldsLocalState = getMySpaceVisibleFields(containerId);
  //     if (visibleFieldsLocalState) {
  //       setColumnVisibility(visibleFieldsLocalState);
  //     }
  //     setColumnOrder(columnOrderLocalState || []);
  //   }
  // }, [containerId]);

  // useEffect(() => {
  //   if (containerId) {
  //     fetchMySpaceHeaderConfig(containerId);
  //   }
  // }, []);

  // SHOW SINGLE FORM AT CERTAIN CONDITION
  useEffect(() => {
    if (headerConfigDataRaw?.is_multi_records === false && mySpaceBodyRaw?.success) {
      handleSingleAddRecord();
    } else {
      setShowSingleForm({ show: false, data: [] });
    }
  }, [headerConfigDataRaw, mySpaceBodyRaw]);

  const closeTaskDrawer = () => {
    setIsTaskDrawerOpen(false);
  };

  // console.log("fieldOrder columnOrder:", columnOrder, tableColumnsVisibility);

  return (
    <Fragment>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          // Optional: reset state, refetch, or navigate to safe path
          window.location.reload();
        }}
      >
        {isTaskDrawerOpen && (
          <TasListkModal
            isOpen={isTaskDrawerOpen}
            openSecondPopup={openSecondPopup}
            closePopup={closeTaskDrawer}
            customerId={taskClickCustomer?.id}
            rowId={taskClickCustomer?.rowId}
            secondPopupOpen={secondPopupOpen}
            leadTypeValue={leadTypeValue}
            isTaskPodSuccess={isTaskPodSuccess}
            moduleId={containerId}
          />
        )}
        <div className="h-full" id="innercontent">
          {true && (
            <div
              id="default-styled-tab-content"
              className="tablemaindiv h-full"
              // style={{ display: showListView ? "block" : "none" }}
            >
              <div className={`h-full `} id="styled-profile" role="tabpanel" aria-labelledby="profile-tab">
                {(headerConfigDataRaw?.is_multi_records || isCompanyLevel) && (
                  <div className="h-full">
                    <CustomerReactTable
                      headers={columns || []}
                      body={memoizedCustomerData || []}
                      tableDetail={{
                        tableFilter:
                          subNavitems?.length > 0 ? (
                            <h2
                              className={`py-2 cursor-pointer text-base font-medium hover:text-primary-70 border-b-2 px-2 border-primary text-primary whitespace-nowrap   `}
                            >
                              {subNavitems[0]?.label}
                            </h2>
                          ) : (
                            <h2
                              className={`py-2 cursor-pointer text-base font-medium hover:text-primary-70 border-b-2 px-2 border-primary text-primary whitespace-nowrap   `}
                            >
                              List
                            </h2>
                          ),
                      }}
                      // isMySpace
                      isCustomModule={true}
                      fetchPersonInTable={fetchPersonData}
                      rawHeaders={headerConfigData}
                      fetchtableBodyData={fetchFieldOptions}
                      customerCommnData={fieldOptionsData}
                      TableFieldUpdate={handleTableFieldUpdate}
                      noExcelDownload={false}
                      narrowHeader
                      ExtraFields={
                        <div className="flex items-center h-full">
                          <div className="flex items-center ml-1">
                            {/* {(!isCompanyLevel || headerConfigDataRaw?.only_company_level) && ( */}
                            {!isCompanyLevel && (
                              <SubmoduleNav
                                items={subNavitems ?? subModulesItems}
                                subTabValue={"dashboard"}
                                disableRouting
                                onSelect={(val) => setActiveSubmodule(val)}
                              />
                            )}

                            {Object.keys(multiData)?.length > 0 && (
                              <div>
                                <button
                                  onClick={() => {
                                    setIsActive(!isActive);
                                    setShowConfirmDialog({
                                      show: true,
                                      data: {
                                        title: "Delete",
                                        message: "Are you sure want to delete Selected Items?",
                                        callback: deleteBulkRowsInTable,
                                        variant: "delete",
                                        confirmText: "Delete",
                                        cancelText: "Cancel",
                                      },
                                    });
                                  }}
                                  className={`flex items-center gap-2 py-1 px-2 rounded 
                                  ${isActive ? "bg-red-100 text-red-600" : "text-red-600 hover:bg-red-100"}
                                `}
                                >
                                  <DeleteIcon />
                                  Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      }
                      MainFields={
                        <div className="flex items-center h-full">
                          <div className="flex items-center ml-1">
                            {Object.keys(multiData)?.length > 0 && (
                              <div>
                                <button
                                  onClick={() => {
                                    setIsActive(!isActive);
                                    setShowConfirmDialog({
                                      show: true,
                                      data: {
                                        title: "Delete",
                                        message: "Are you sure want to delete Selected Items?",
                                        callback: deleteBulkRowsInTable,
                                        variant: "delete",
                                        confirmText: "Delete",
                                        cancelText: "Cancel",
                                      },
                                    });
                                  }}
                                  className={`flex items-center gap-2 py-1 px-2 rounded 
                                  ${isActive ? "bg-red-100 text-red-600" : "text-red-600 hover:bg-red-100"}
                                `}
                                >
                                  <DeleteIcon />
                                  Delete
                                </button>
                              </div>
                            )}

                            <ToolTipComponent text="Manage View" style={{ color: "#1D4469 " }}>
                              <span
                                onClick={() => setIsManageFieldOpen((prev) => !prev)}
                                className="cursor-pointer  border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                              >
                                <ManageIcon isActive={isManageFieldOpen} isHovered={isMangeHovered} />
                              </span>
                            </ToolTipComponent>

                            {(!isCompanyLevel || headerConfigDataRaw?.only_company_level) && (
                              <button
                                onClick={() => {
                                  handleAddRow();
                                  setSelectedtableRowId(null);
                                  setIsActiveAddItem(true);
                                }}
                                className="group flex items-center  py-1  rounded text-gray-600 
                                            border border-transparent hover:border-[#004EFF] transition-colors duration-200"
                              >
                                <AddItemPlus isActive={isActiveAddItem} />
                              </button>
                            )}
                          </div>
                        </div>
                      }
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      columnOrder={columnOrder}
                      totalCount={totalCount}
                      multiData={multiData}
                      setMultiData={setMultiData}
                      grouping={grouping}
                      setGrouping={setGrouping}
                      resetPageIndex={resetPageIndex}
                      setResetPageIndex={setResetPageIndex}
                      globalFilter={globalFilter}
                      setGlobalFilter={setGlobalFilter}
                      showColumnEdit={true}
                      showColumnDelete={true}
                      editColumnCallBack={handleEditColumn}
                      columnVisibility={columnVisibility}
                      // setColumnVisibility={setTableColumnsVisibility}
                      handleReorderFields={(srcInd, targetInd) => handleReorderFields(srcInd + 1, targetInd + 1)}
                      // ExtraFields={<InternalNavigationRounded items={subNavitems} subTabValue={"dashboard"} />}
                      deleteColumnCallBack={(columnId) => {
                        setShowConfirmDialog({
                          show: true,
                          data: {
                            title: "Delete",
                            message: "Are you sure want to delete this column?",
                            callback: () => handleDeleteColumn(columnId),
                            variant: "delete",
                            confirmText: "Delete",
                            cancelText: "Cancel",
                          },
                        });
                      }}
                      rowClickDisabled={true}
                      headerConfigData={headerConfigData}
                      isMySpaceCreateColumnHtml={isMySpaceCreateColumnHtml}
                      noMenuOpenList={["is_deletable", "select"]}
                      apiStates={{
                        header: {
                          isLoading: false,
                          isError: false,
                        },
                        body: {
                          isLoading: false,
                          isError: false,
                        },
                      }}
                      alternateDivs={{
                        emptyData: (
                          <>
                            <div className="w-full h-full">
                              <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                                {/* <NoCustomerData className="h-[300px] w-[300px]" /> */}
                                <span className="text-14 text-black text-sm font-400 font-poppins ">
                                  No Customer Data is Available.
                                </span>
                              </div>
                            </div>
                          </>
                        ),
                      }}
                      generateUniqueValues={generateUniqueValuesForCustomDashboard}
                      useGenerateUniqueValues={true}
                      useBuildOptionsFromList={true}
                      buildOptionsFromList={buildOptionsFromListForCustomDashboard}
                    />
                  </div>
                )}

                {!isCompanyLevel && showSingleForm?.show && showSingleForm?.data?.length > 0 && (
                  <div>
                    <div className="border-b border-[#E9E9E9]">
                      <InternalNavigation items={subNavitems} subTabValue={"dashboard"} isIcons />
                    </div>
                    <CustomRender
                      headerData={headerSingleFormat}
                      headerBodyData={headerBodyFormat}
                      onSubmit={handleSingleUpdateField}
                      fetchDropdownApi={handleFetchDropdownOptions}
                      dropdownOptions={dropdownOptionsData}
                      isCustomModule={true}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {extraField && (
          <AddFieldDrawer
            open={extraField}
            onClose={() => {
              setExtraField((prev) => !prev);
              setIsEditableFieldModeActive(null);
            }}
            ExtraFieldAddHeader={handleAddTableColumn}
            EditFieldData={isEditableFieldModeActive}
            handleDeleteOption={(info) => {
              handleDeleteTableColumnOption(info?.field_id, info?.uuid);
            }}
            handleUpdateTableColumn={handleUpdateTableColumn}
            isMySpace={true}
            isBilling={true}
          />
        )}

        {showConfirmDialog?.show && (
          <ConfirmationDialog
            open={showConfirmDialog?.show}
            title={showConfirmDialog?.data?.title}
            message={showConfirmDialog?.data?.message}
            iconVariant={showConfirmDialog?.data?.variant}
            onClose={() => setShowConfirmDialog(() => ({ data: {}, show: false }))}
            onConfirm={() => {
              showConfirmDialog?.data?.callback();
              setShowConfirmDialog(() => ({ data: {}, show: false }));
            }}
            onCancel={() => setShowConfirmDialog(() => ({ data: {}, show: false }))}
            confirmVariant={showConfirmDialog?.data?.variant}
            confirmText={showConfirmDialog?.data?.confirmText}
            cancelText={showConfirmDialog?.data?.cancelText}
          />
        )}

        {showAddEditModal?.show > 0 && (
          <TableListRowAddEditComponent
            open={showAddEditModal?.show > 0}
            onClose={() => {
              setShowAddEditModal({});
              setIsActiveAddItem(false);
            }}
            prefilledFormData={showAddEditModal?.data}
            onSubmit={handleRowAddEditSubmit}
            mode={rowAddEditMode}
          />
        )}

        {/* {menuVisible && (
          <ManageFieldDrawer
            headerConfig={headerConfigData}
            listViewData={columnVisibility}
            handleFieldVisibility={handleFieldVisibility}
            close={() => setIsManageFieldOpen(false)}
            isOpen={menuVisible}
            fieldOptionsData={fieldOptionsData}
            fetchFieldOptions={fetchFieldOptions}
            handleUpdateTableColumn={handleUpdateTableColumn}
            handleReorderFields={handleReorderFields}
            isMySpace={true}
            handleEditColumn={(columnValue) => handleEditColumn({ id: columnValue })}
            setExtraField={() => setExtraField((prev) => !prev)}
            removeFieldApi={(columnValue) => {
              setShowConfirmDialog({
                show: true,
                data: {
                  title: "Delete",
                  message: "Are you sure want to delete this column?",
                  callback: () => handleDeleteColumn({ id: columnValue }),
                  variant: "delete",
                  confirmText: "Delete",
                  cancelText: "Cancel",
                },
              });
            }}
          />
        )} */}

        {isManageFieldOpen && (
          <ManageFieldDrawer
            headerConfig={headerConfigData}
            listViewData={
              (columnVisibility && {
                hidden_fields: getHiddenFields(columnVisibility),
                visible_fields: columnOrder,
              }) ??
              {}
            }
            handleFieldVisibility={handleFieldVisibility}
            close={() => setIsManageFieldOpen(false)}
            isOpen={isManageFieldOpen}
            handleReorderFields={handleReorderFields}
            handleSave={handlePostMeta}
          />
        )}

        {
          <ConfirmationDialogMulti
            open={showDeleteDialog?.id}
            onClose={() => {
              setShowDeleteDialog(false);
            }}
            title="Delete Entire Raw ?"
            message="Are you sure you want to delete the entire raw? This action cannot be undone."
            onConfirm={() => {
              deleteSingleRowInTable([showDeleteDialog?.id]);
            }}
            onCancel={() => {
              setShowDeleteDialog(false);
            }}
            confirmVariant="delete"
            cancelVariant="secondary"
            confirmText="Delete"
            cancelText="Cancel"
            iconVariant="delete"
          />
        }

        {isDocumentOpen && (
          <DocumentDrawer
            isOpen={isDocumentOpen}
            isDocumentOpen={isDocumentOpen}
            onClose={() => setIsDocumentOpen(false)}
          />
        )}

        {isNotesOpen && (
          <ViewNotesDrawer
            Item={{
              id: customerData?.id || customerIdForCompanyLevel,
              company_id: customerData?.company_id,
              name: customerData?.customer_name,
              template_id: propTemplateId || templateId,
              row_id: isNotesOpen,
            }}
            isOpen={isNotesOpen}
            handleCloseNotes={handleCloseNotes}
            refetch={handleNotesDataRefetch}
            isCustomModule={true}
            sectionType="Tracking"
          />
        )}

        {rowData && (
          <RedirectModulePreview
            rowData={rowData}
            setRowData={setRowData}
            onClose={() => {
              setRowData(null);
            }}
            items={subNavitems || subModulesItems}
            isCompanyLevel={isCompanyLevel}
            propTemplateId={propTemplateId}
            customerId={customerId}
          />
        )}

        {secondPopupOpen && (
          <DynamicAddTaskPodModal
            taskid={taskId}
            templateId={taskClickCustomer?.id}
            isOpen={secondPopupOpen}
            closePopup={closeSecondPopup}
            onClose={closeSecondPopup}
            setAlert={setAlert}
            alert={alert}
            leadTypeValue={leadTypeValue}
            setLeadTypeValue={setLeadTypeValue}
            selectedCustomer={{
              customer_name: taskClickCustomer?.customer_name,
              customer_id: taskClickCustomer?.id,
              id: taskClickCustomer?.id,
            }}
            //firstPopupOpen={firstPopupOpen}
            refetch={refetchCustomerDataNode}
            setRefetchByTask={setRefetchByTask}
            // refetch={secondPopupOpen?.refetchTaskData}
            isDoubleComp={taskId?.recurModal}
            recurModal={taskId?.recurModal}
            activeModal={taskId?.activeModal}
            externalApi={{
              createUpdateTask: (data) => handleSubmitTask(data),
            }}
            isCompanyLevel={headerConfigDataRaw?.only_company_level || null}
          />
        )}

        {activeSubmodule && activeSubmodule.value && (
          <Submodules
            activeSubmodule={activeSubmodule}
            setActiveSubmodule={setActiveSubmodule}
            onClose={() => setActiveSubmodule(null)}
            items={subNavitems || subModulesItems}
            moduleId={propTemplateId || templateId}
          />
        )}
      </ErrorBoundary>
    </Fragment>
  );
};

export default CustomDashboard;
